
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fa2Fq", function(module, exports) {
'use strict';
var $b099dbd68238d6ce$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $9VQ4N = parcelRequire("9VQ4N");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $b099dbd68238d6ce$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $b099dbd68238d6ce$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $9VQ4N();
};

});
parcelRegister("9VQ4N", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});





var $9d72a09537a5cbc3$var$n, $9d72a09537a5cbc3$export$41c562ebe57d11e2, $9d72a09537a5cbc3$var$u, $9d72a09537a5cbc3$export$a8257692ac88316c, $9d72a09537a5cbc3$var$i, $9d72a09537a5cbc3$var$r, $9d72a09537a5cbc3$var$o, $9d72a09537a5cbc3$var$e, $9d72a09537a5cbc3$var$f, $9d72a09537a5cbc3$var$c, $9d72a09537a5cbc3$var$s, $9d72a09537a5cbc3$var$a, $9d72a09537a5cbc3$var$h, $9d72a09537a5cbc3$var$p = {}, $9d72a09537a5cbc3$var$v = [], $9d72a09537a5cbc3$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $9d72a09537a5cbc3$var$w = Array.isArray;
function $9d72a09537a5cbc3$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $9d72a09537a5cbc3$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $9d72a09537a5cbc3$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $9d72a09537a5cbc3$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $9d72a09537a5cbc3$var$m(l, e, i, r, null);
}
function $9d72a09537a5cbc3$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$9d72a09537a5cbc3$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $9d72a09537a5cbc3$export$41c562ebe57d11e2.vnode && $9d72a09537a5cbc3$export$41c562ebe57d11e2.vnode(e), e;
}
function $9d72a09537a5cbc3$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $9d72a09537a5cbc3$export$ffb0004e005737fa(n) {
    return n.children;
}
function $9d72a09537a5cbc3$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $9d72a09537a5cbc3$var$S(n, l) {
    if (null == l) return n.__ ? $9d72a09537a5cbc3$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $9d72a09537a5cbc3$var$S(n) : null;
}
function $9d72a09537a5cbc3$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $9d72a09537a5cbc3$var$C(n);
    }
}
function $9d72a09537a5cbc3$var$M(n) {
    (!n.__d && (n.__d = !0) && $9d72a09537a5cbc3$var$i.push(n) && !$9d72a09537a5cbc3$var$$.__r++ || $9d72a09537a5cbc3$var$r != $9d72a09537a5cbc3$export$41c562ebe57d11e2.debounceRendering) && (($9d72a09537a5cbc3$var$r = $9d72a09537a5cbc3$export$41c562ebe57d11e2.debounceRendering) || $9d72a09537a5cbc3$var$o)($9d72a09537a5cbc3$var$$);
}
function $9d72a09537a5cbc3$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $9d72a09537a5cbc3$var$i.length;)$9d72a09537a5cbc3$var$i.length > s && $9d72a09537a5cbc3$var$i.sort($9d72a09537a5cbc3$var$e), n = $9d72a09537a5cbc3$var$i.shift(), s = $9d72a09537a5cbc3$var$i.length, n.__d && (t = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $9d72a09537a5cbc3$var$d({}, r)).__v = r.__v + 1, $9d72a09537a5cbc3$export$41c562ebe57d11e2.vnode && $9d72a09537a5cbc3$export$41c562ebe57d11e2.vnode(t), $9d72a09537a5cbc3$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $9d72a09537a5cbc3$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $9d72a09537a5cbc3$var$z(f, t, c), t.__e != o && $9d72a09537a5cbc3$var$C(t)));
    $9d72a09537a5cbc3$var$$.__r = 0;
}
function $9d72a09537a5cbc3$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _ = t && t.__k || $9d72a09537a5cbc3$var$v, m = l.length;
    for(f = $9d72a09537a5cbc3$var$P(u, l, _, f, m), a = 0; a < m; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $9d72a09537a5cbc3$var$p : _[y.__i] || $9d72a09537a5cbc3$var$p, y.__i = a, g = $9d72a09537a5cbc3$var$O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && $9d72a09537a5cbc3$var$q(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), 4 & y.__u || h.__k === y.__k ? f = $9d72a09537a5cbc3$var$A(y, f, n) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function $9d72a09537a5cbc3$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $9d72a09537a5cbc3$var$m(null, o, null, null, null) : $9d72a09537a5cbc3$var$w(o) ? $9d72a09537a5cbc3$var$m($9d72a09537a5cbc3$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? $9d72a09537a5cbc3$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $9d72a09537a5cbc3$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $9d72a09537a5cbc3$var$S(e)), $9d72a09537a5cbc3$var$B(e, e));
    return t;
}
function $9d72a09537a5cbc3$var$A(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $9d72a09537a5cbc3$var$A(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $9d72a09537a5cbc3$var$S(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $9d72a09537a5cbc3$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($9d72a09537a5cbc3$var$w(n) ? n.some(function(n) {
        $9d72a09537a5cbc3$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $9d72a09537a5cbc3$var$L(n, l, u, t) {
    var i, r, o = n.key, e = n.type, f = l[u];
    if (null === f && null == n.key || f && o == f.key && e == f.type && 0 == (2 & f.__u)) return u;
    if (t > (null != f && 0 == (2 & f.__u) ? 1 : 0)) for(i = u - 1, r = u + 1; i >= 0 || r < l.length;){
        if (i >= 0) {
            if ((f = l[i]) && 0 == (2 & f.__u) && o == f.key && e == f.type) return i;
            i--;
        }
        if (r < l.length) {
            if ((f = l[r]) && 0 == (2 & f.__u) && o == f.key && e == f.type) return r;
            r++;
        }
    }
    return -1;
}
function $9d72a09537a5cbc3$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $9d72a09537a5cbc3$var$y.test(l) ? u : u + "px";
}
function $9d72a09537a5cbc3$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $9d72a09537a5cbc3$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $9d72a09537a5cbc3$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($9d72a09537a5cbc3$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $9d72a09537a5cbc3$var$c, n.addEventListener(l, r ? $9d72a09537a5cbc3$var$a : $9d72a09537a5cbc3$var$s, r)) : n.removeEventListener(l, r ? $9d72a09537a5cbc3$var$a : $9d72a09537a5cbc3$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $9d72a09537a5cbc3$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $9d72a09537a5cbc3$var$c++;
            else if (u.t < t.u) return;
            return t($9d72a09537a5cbc3$export$41c562ebe57d11e2.event ? $9d72a09537a5cbc3$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $9d72a09537a5cbc3$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $9d72a09537a5cbc3$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $9d72a09537a5cbc3$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $9d72a09537a5cbc3$var$D), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $9d72a09537a5cbc3$var$d({}, h.__s)), $9d72a09537a5cbc3$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $9d72a09537a5cbc3$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $9d72a09537a5cbc3$var$d($9d72a09537a5cbc3$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $9d72a09537a5cbc3$export$ffb0004e005737fa && null == a.key && (L = $9d72a09537a5cbc3$var$N(a.props.children)), f = $9d72a09537a5cbc3$var$I(n, $9d72a09537a5cbc3$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else for(T = o.length; T--;)$9d72a09537a5cbc3$var$g(o[T]);
        } else u.__e = t.__e, u.__k = t.__k;
        $9d72a09537a5cbc3$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $9d72a09537a5cbc3$var$V(t.__e, u, t, i, r, o, e, c, s);
    return (a = $9d72a09537a5cbc3$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $9d72a09537a5cbc3$var$z(n, u, t) {
    for(var i = 0; i < t.length; i++)$9d72a09537a5cbc3$var$q(t[i], t[++i], t[++i]);
    $9d72a09537a5cbc3$export$41c562ebe57d11e2.__c && $9d72a09537a5cbc3$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $9d72a09537a5cbc3$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $9d72a09537a5cbc3$var$N(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $9d72a09537a5cbc3$var$w(n) ? n.map($9d72a09537a5cbc3$var$N) : $9d72a09537a5cbc3$var$d({}, n);
}
function $9d72a09537a5cbc3$var$V(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($9d72a09537a5cbc3$export$41c562ebe57d11e2.__m && $9d72a09537a5cbc3$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $9d72a09537a5cbc3$var$n.call(u.childNodes), b = i.props || $9d72a09537a5cbc3$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $9d72a09537a5cbc3$var$j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $9d72a09537a5cbc3$var$j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $9d72a09537a5cbc3$var$I("template" == t.type ? u.content : u, $9d72a09537a5cbc3$var$w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $9d72a09537a5cbc3$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$9d72a09537a5cbc3$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $9d72a09537a5cbc3$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $9d72a09537a5cbc3$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $9d72a09537a5cbc3$var$q(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $9d72a09537a5cbc3$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $9d72a09537a5cbc3$var$B(n, u, t) {
    var i, r;
    if ($9d72a09537a5cbc3$export$41c562ebe57d11e2.unmount && $9d72a09537a5cbc3$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $9d72a09537a5cbc3$var$q(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $9d72a09537a5cbc3$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $9d72a09537a5cbc3$var$B(i[r], u, t || "function" != typeof n.type);
    t || $9d72a09537a5cbc3$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $9d72a09537a5cbc3$var$D(n, l, u) {
    return this.constructor(n, u);
}
function $9d72a09537a5cbc3$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $9d72a09537a5cbc3$export$41c562ebe57d11e2.__ && $9d72a09537a5cbc3$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $9d72a09537a5cbc3$var$O(t, u = (!r && i || t).__k = $9d72a09537a5cbc3$export$c8a8987d4410bf2d($9d72a09537a5cbc3$export$ffb0004e005737fa, null, [
        u
    ]), o || $9d72a09537a5cbc3$var$p, $9d72a09537a5cbc3$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $9d72a09537a5cbc3$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $9d72a09537a5cbc3$var$z(e, u, f);
}
function $9d72a09537a5cbc3$export$fa8d919ba61d84db(n, l) {
    $9d72a09537a5cbc3$export$b3890eb0ae9dca99(n, l, $9d72a09537a5cbc3$export$fa8d919ba61d84db);
}
function $9d72a09537a5cbc3$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $9d72a09537a5cbc3$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $9d72a09537a5cbc3$var$n.call(arguments, 2) : t), $9d72a09537a5cbc3$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $9d72a09537a5cbc3$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $9d72a09537a5cbc3$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $9d72a09537a5cbc3$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$9d72a09537a5cbc3$var$n = $9d72a09537a5cbc3$var$v.slice, $9d72a09537a5cbc3$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $9d72a09537a5cbc3$var$u = 0, $9d72a09537a5cbc3$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $9d72a09537a5cbc3$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $9d72a09537a5cbc3$var$d({}, this.state), "function" == typeof n && (n = n($9d72a09537a5cbc3$var$d({}, u), this.props)), n && $9d72a09537a5cbc3$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $9d72a09537a5cbc3$var$M(this));
}, $9d72a09537a5cbc3$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $9d72a09537a5cbc3$var$M(this));
}, $9d72a09537a5cbc3$export$16fa2f45be04daa8.prototype.render = $9d72a09537a5cbc3$export$ffb0004e005737fa, $9d72a09537a5cbc3$var$i = [], $9d72a09537a5cbc3$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $9d72a09537a5cbc3$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $9d72a09537a5cbc3$var$$.__r = 0, $9d72a09537a5cbc3$var$f = /(PointerCapture)$|Capture$/i, $9d72a09537a5cbc3$var$c = 0, $9d72a09537a5cbc3$var$s = $9d72a09537a5cbc3$var$F(!1), $9d72a09537a5cbc3$var$a = $9d72a09537a5cbc3$var$F(!0), $9d72a09537a5cbc3$var$h = 0;


var $358d0673515ab87d$exports = {};
'use strict';
var $4e0981a8baadc926$exports = {};
'use strict';
var $5bb37b4834f07dfc$exports = {};
'use strict';
var $e7333cdb62297eef$exports = {};
'use strict';
/** @type {import('./type')} */ $e7333cdb62297eef$exports = TypeError;


var $099e73f2f1d394e5$exports = {};
var $099e73f2f1d394e5$var$hasMap = typeof Map === 'function' && Map.prototype;
var $099e73f2f1d394e5$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $099e73f2f1d394e5$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $099e73f2f1d394e5$var$mapSize = $099e73f2f1d394e5$var$hasMap && $099e73f2f1d394e5$var$mapSizeDescriptor && typeof $099e73f2f1d394e5$var$mapSizeDescriptor.get === 'function' ? $099e73f2f1d394e5$var$mapSizeDescriptor.get : null;
var $099e73f2f1d394e5$var$mapForEach = $099e73f2f1d394e5$var$hasMap && Map.prototype.forEach;
var $099e73f2f1d394e5$var$hasSet = typeof Set === 'function' && Set.prototype;
var $099e73f2f1d394e5$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $099e73f2f1d394e5$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $099e73f2f1d394e5$var$setSize = $099e73f2f1d394e5$var$hasSet && $099e73f2f1d394e5$var$setSizeDescriptor && typeof $099e73f2f1d394e5$var$setSizeDescriptor.get === 'function' ? $099e73f2f1d394e5$var$setSizeDescriptor.get : null;
var $099e73f2f1d394e5$var$setForEach = $099e73f2f1d394e5$var$hasSet && Set.prototype.forEach;
var $099e73f2f1d394e5$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $099e73f2f1d394e5$var$weakMapHas = $099e73f2f1d394e5$var$hasWeakMap ? WeakMap.prototype.has : null;
var $099e73f2f1d394e5$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $099e73f2f1d394e5$var$weakSetHas = $099e73f2f1d394e5$var$hasWeakSet ? WeakSet.prototype.has : null;
var $099e73f2f1d394e5$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $099e73f2f1d394e5$var$weakRefDeref = $099e73f2f1d394e5$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $099e73f2f1d394e5$var$booleanValueOf = Boolean.prototype.valueOf;
var $099e73f2f1d394e5$var$objectToString = Object.prototype.toString;
var $099e73f2f1d394e5$var$functionToString = Function.prototype.toString;
var $099e73f2f1d394e5$var$$match = String.prototype.match;
var $099e73f2f1d394e5$var$$slice = String.prototype.slice;
var $099e73f2f1d394e5$var$$replace = String.prototype.replace;
var $099e73f2f1d394e5$var$$toUpperCase = String.prototype.toUpperCase;
var $099e73f2f1d394e5$var$$toLowerCase = String.prototype.toLowerCase;
var $099e73f2f1d394e5$var$$test = RegExp.prototype.test;
var $099e73f2f1d394e5$var$$concat = Array.prototype.concat;
var $099e73f2f1d394e5$var$$join = Array.prototype.join;
var $099e73f2f1d394e5$var$$arrSlice = Array.prototype.slice;
var $099e73f2f1d394e5$var$$floor = Math.floor;
var $099e73f2f1d394e5$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $099e73f2f1d394e5$var$gOPS = Object.getOwnPropertySymbols;
var $099e73f2f1d394e5$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $099e73f2f1d394e5$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $099e73f2f1d394e5$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $099e73f2f1d394e5$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $099e73f2f1d394e5$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $099e73f2f1d394e5$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $099e73f2f1d394e5$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $099e73f2f1d394e5$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$099e73f2f1d394e5$var$$floor(-num) : $099e73f2f1d394e5$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $099e73f2f1d394e5$var$$slice.call(str, intStr.length + 1);
            return $099e73f2f1d394e5$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $099e73f2f1d394e5$var$$replace.call($099e73f2f1d394e5$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $099e73f2f1d394e5$var$$replace.call(str, sepRegex, '$&_');
}
var $7fb48c2bf03d629c$exports = {};
"use strict";


var $099e73f2f1d394e5$var$inspectCustom = $7fb48c2bf03d629c$exports.custom;
var $099e73f2f1d394e5$var$inspectSymbol = $099e73f2f1d394e5$var$isSymbol($099e73f2f1d394e5$var$inspectCustom) ? $099e73f2f1d394e5$var$inspectCustom : null;
var $099e73f2f1d394e5$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $099e73f2f1d394e5$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$099e73f2f1d394e5$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($099e73f2f1d394e5$var$has(opts, 'quoteStyle') && !$099e73f2f1d394e5$var$has($099e73f2f1d394e5$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($099e73f2f1d394e5$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $099e73f2f1d394e5$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($099e73f2f1d394e5$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($099e73f2f1d394e5$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $099e73f2f1d394e5$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $099e73f2f1d394e5$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $099e73f2f1d394e5$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $099e73f2f1d394e5$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $099e73f2f1d394e5$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($099e73f2f1d394e5$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $099e73f2f1d394e5$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($099e73f2f1d394e5$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$099e73f2f1d394e5$var$isRegExp(obj)) {
        var name = $099e73f2f1d394e5$var$nameOf(obj);
        var keys = $099e73f2f1d394e5$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $099e73f2f1d394e5$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($099e73f2f1d394e5$var$isSymbol(obj)) {
        var symString = $099e73f2f1d394e5$var$hasShammedSymbols ? $099e73f2f1d394e5$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $099e73f2f1d394e5$var$symToString.call(obj);
        return typeof obj === 'object' && !$099e73f2f1d394e5$var$hasShammedSymbols ? $099e73f2f1d394e5$var$markBoxed(symString) : symString;
    }
    if ($099e73f2f1d394e5$var$isElement(obj)) {
        var s = '<' + $099e73f2f1d394e5$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $099e73f2f1d394e5$var$wrapQuotes($099e73f2f1d394e5$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $099e73f2f1d394e5$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($099e73f2f1d394e5$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $099e73f2f1d394e5$var$arrObjKeys(obj, inspect);
        if (indent && !$099e73f2f1d394e5$var$singleLineValues(xs)) return '[' + $099e73f2f1d394e5$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $099e73f2f1d394e5$var$$join.call(xs, ', ') + ' ]';
    }
    if ($099e73f2f1d394e5$var$isError(obj)) {
        var parts = $099e73f2f1d394e5$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$099e73f2f1d394e5$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $099e73f2f1d394e5$var$$join.call($099e73f2f1d394e5$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $099e73f2f1d394e5$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($099e73f2f1d394e5$var$inspectSymbol && typeof obj[$099e73f2f1d394e5$var$inspectSymbol] === 'function' && $7fb48c2bf03d629c$exports) return $7fb48c2bf03d629c$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($099e73f2f1d394e5$var$isMap(obj)) {
        var mapParts = [];
        if ($099e73f2f1d394e5$var$mapForEach) $099e73f2f1d394e5$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $099e73f2f1d394e5$var$collectionOf('Map', $099e73f2f1d394e5$var$mapSize.call(obj), mapParts, indent);
    }
    if ($099e73f2f1d394e5$var$isSet(obj)) {
        var setParts = [];
        if ($099e73f2f1d394e5$var$setForEach) $099e73f2f1d394e5$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $099e73f2f1d394e5$var$collectionOf('Set', $099e73f2f1d394e5$var$setSize.call(obj), setParts, indent);
    }
    if ($099e73f2f1d394e5$var$isWeakMap(obj)) return $099e73f2f1d394e5$var$weakCollectionOf('WeakMap');
    if ($099e73f2f1d394e5$var$isWeakSet(obj)) return $099e73f2f1d394e5$var$weakCollectionOf('WeakSet');
    if ($099e73f2f1d394e5$var$isWeakRef(obj)) return $099e73f2f1d394e5$var$weakCollectionOf('WeakRef');
    if ($099e73f2f1d394e5$var$isNumber(obj)) return $099e73f2f1d394e5$var$markBoxed(inspect(Number(obj)));
    if ($099e73f2f1d394e5$var$isBigInt(obj)) return $099e73f2f1d394e5$var$markBoxed(inspect($099e73f2f1d394e5$var$bigIntValueOf.call(obj)));
    if ($099e73f2f1d394e5$var$isBoolean(obj)) return $099e73f2f1d394e5$var$markBoxed($099e73f2f1d394e5$var$booleanValueOf.call(obj));
    if ($099e73f2f1d394e5$var$isString(obj)) return $099e73f2f1d394e5$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$099e73f2f1d394e5$var$isDate(obj) && !$099e73f2f1d394e5$var$isRegExp(obj)) {
        var ys = $099e73f2f1d394e5$var$arrObjKeys(obj, inspect);
        var isPlainObject = $099e73f2f1d394e5$var$gPO ? $099e73f2f1d394e5$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $099e73f2f1d394e5$var$toStringTag && Object(obj) === obj && $099e73f2f1d394e5$var$toStringTag in obj ? $099e73f2f1d394e5$var$$slice.call($099e73f2f1d394e5$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $099e73f2f1d394e5$var$$join.call($099e73f2f1d394e5$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $099e73f2f1d394e5$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $099e73f2f1d394e5$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $099e73f2f1d394e5$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $099e73f2f1d394e5$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $099e73f2f1d394e5$var$quote(s) {
    return $099e73f2f1d394e5$var$$replace.call(String(s), /"/g, '&quot;');
}
function $099e73f2f1d394e5$var$canTrustToString(obj) {
    return !$099e73f2f1d394e5$var$toStringTag || !(typeof obj === 'object' && ($099e73f2f1d394e5$var$toStringTag in obj || typeof obj[$099e73f2f1d394e5$var$toStringTag] !== 'undefined'));
}
function $099e73f2f1d394e5$var$isArray(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object Array]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isDate(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object Date]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isRegExp(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object RegExp]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isError(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object Error]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isString(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object String]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isNumber(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object Number]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isBoolean(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object Boolean]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $099e73f2f1d394e5$var$isSymbol(obj) {
    if ($099e73f2f1d394e5$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$099e73f2f1d394e5$var$symToString) return false;
    try {
        $099e73f2f1d394e5$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$099e73f2f1d394e5$var$bigIntValueOf) return false;
    try {
        $099e73f2f1d394e5$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $099e73f2f1d394e5$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $099e73f2f1d394e5$var$has(obj, key) {
    return $099e73f2f1d394e5$var$hasOwn.call(obj, key);
}
function $099e73f2f1d394e5$var$toStr(obj) {
    return $099e73f2f1d394e5$var$objectToString.call(obj);
}
function $099e73f2f1d394e5$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $099e73f2f1d394e5$var$$match.call($099e73f2f1d394e5$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $099e73f2f1d394e5$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $099e73f2f1d394e5$var$isMap(x) {
    if (!$099e73f2f1d394e5$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $099e73f2f1d394e5$var$mapSize.call(x);
        try {
            $099e73f2f1d394e5$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isWeakMap(x) {
    if (!$099e73f2f1d394e5$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $099e73f2f1d394e5$var$weakMapHas.call(x, $099e73f2f1d394e5$var$weakMapHas);
        try {
            $099e73f2f1d394e5$var$weakSetHas.call(x, $099e73f2f1d394e5$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isWeakRef(x) {
    if (!$099e73f2f1d394e5$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $099e73f2f1d394e5$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isSet(x) {
    if (!$099e73f2f1d394e5$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $099e73f2f1d394e5$var$setSize.call(x);
        try {
            $099e73f2f1d394e5$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isWeakSet(x) {
    if (!$099e73f2f1d394e5$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $099e73f2f1d394e5$var$weakSetHas.call(x, $099e73f2f1d394e5$var$weakSetHas);
        try {
            $099e73f2f1d394e5$var$weakMapHas.call(x, $099e73f2f1d394e5$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $099e73f2f1d394e5$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $099e73f2f1d394e5$var$inspectString($099e73f2f1d394e5$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $099e73f2f1d394e5$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $099e73f2f1d394e5$var$$replace.call($099e73f2f1d394e5$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $099e73f2f1d394e5$var$lowbyte);
    return $099e73f2f1d394e5$var$wrapQuotes(s, 'single', opts);
}
function $099e73f2f1d394e5$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $099e73f2f1d394e5$var$$toUpperCase.call(n.toString(16));
}
function $099e73f2f1d394e5$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $099e73f2f1d394e5$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $099e73f2f1d394e5$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $099e73f2f1d394e5$var$indentedJoin(entries, indent) : $099e73f2f1d394e5$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $099e73f2f1d394e5$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($099e73f2f1d394e5$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $099e73f2f1d394e5$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $099e73f2f1d394e5$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $099e73f2f1d394e5$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $099e73f2f1d394e5$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $099e73f2f1d394e5$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $099e73f2f1d394e5$var$arrObjKeys(obj, inspect) {
    var isArr = $099e73f2f1d394e5$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $099e73f2f1d394e5$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $099e73f2f1d394e5$var$gOPS === 'function' ? $099e73f2f1d394e5$var$gOPS(obj) : [];
    var symMap;
    if ($099e73f2f1d394e5$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$099e73f2f1d394e5$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($099e73f2f1d394e5$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($099e73f2f1d394e5$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $099e73f2f1d394e5$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($099e73f2f1d394e5$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $6fb86cf97df15c41$exports = {};
'use strict';


/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $6fb86cf97df15c41$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $6fb86cf97df15c41$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $6fb86cf97df15c41$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $6fb86cf97df15c41$var$listSet = function(objects, key, value) {
    var node = $6fb86cf97df15c41$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $6fb86cf97df15c41$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$6fb86cf97df15c41$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $6fb86cf97df15c41$var$listDelete = function(objects, key) {
    if (objects) return $6fb86cf97df15c41$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ $6fb86cf97df15c41$exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $e7333cdb62297eef$exports('Side channel does not contain ' + $099e73f2f1d394e5$exports(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $6fb86cf97df15c41$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $6fb86cf97df15c41$var$listGet($o, key);
        },
        has: function(key) {
            return $6fb86cf97df15c41$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $6fb86cf97df15c41$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $005dee0701e4a773$exports = {};
'use strict';
var $3a08f3b93b399588$exports = {};
'use strict';
var $3a08f3b93b399588$var$undefined1;
var $780445d60a811bbf$exports = {};
'use strict';
/** @type {import('.')} */ $780445d60a811bbf$exports = Object;


var $1eaffdb23035cbbb$exports = {};
'use strict';
/** @type {import('.')} */ $1eaffdb23035cbbb$exports = Error;


var $0a6c5e1d4184493e$exports = {};
'use strict';
/** @type {import('./eval')} */ $0a6c5e1d4184493e$exports = EvalError;


var $7c5e8489cd9ea6b8$exports = {};
'use strict';
/** @type {import('./range')} */ $7c5e8489cd9ea6b8$exports = RangeError;


var $91d0feb9ab2312c1$exports = {};
'use strict';
/** @type {import('./ref')} */ $91d0feb9ab2312c1$exports = ReferenceError;


var $10c21afc31eb010f$exports = {};
'use strict';
/** @type {import('./syntax')} */ $10c21afc31eb010f$exports = SyntaxError;



var $507a2ecfb86dffac$exports = {};
'use strict';
/** @type {import('./uri')} */ $507a2ecfb86dffac$exports = URIError;


var $249e1f48341b5c56$exports = {};
'use strict';
/** @type {import('./abs')} */ $249e1f48341b5c56$exports = Math.abs;


var $d9a7a967efd8a30b$exports = {};
'use strict';
/** @type {import('./floor')} */ $d9a7a967efd8a30b$exports = Math.floor;


var $a2741222432daf91$exports = {};
'use strict';
/** @type {import('./max')} */ $a2741222432daf91$exports = Math.max;


var $d37082e020955214$exports = {};
'use strict';
/** @type {import('./min')} */ $d37082e020955214$exports = Math.min;


var $cd8c11561a2c9634$exports = {};
'use strict';
/** @type {import('./pow')} */ $cd8c11561a2c9634$exports = Math.pow;


var $c2fb0e7b524e938f$exports = {};
'use strict';
/** @type {import('./round')} */ $c2fb0e7b524e938f$exports = Math.round;


var $63832c8987979246$exports = {};
'use strict';
var $d62f2d58c929b6ea$exports = {};
'use strict';
/** @type {import('./isNaN')} */ $d62f2d58c929b6ea$exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};


/** @type {import('./sign')} */ $63832c8987979246$exports = function sign(number) {
    if ($d62f2d58c929b6ea$exports(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};


var $3a08f3b93b399588$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $3a08f3b93b399588$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $3a08f3b93b399588$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $5bccb8dbb44f329c$exports = {};
'use strict';
var $6265d7e61a9aa63e$exports = {};
'use strict';
/** @type {import('./gOPD')} */ $6265d7e61a9aa63e$exports = Object.getOwnPropertyDescriptor;


var $5bccb8dbb44f329c$require$$gOPD = $6265d7e61a9aa63e$exports;
if ($5bccb8dbb44f329c$require$$gOPD) try {
    $5bccb8dbb44f329c$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $5bccb8dbb44f329c$require$$gOPD = null;
}
$5bccb8dbb44f329c$exports = $5bccb8dbb44f329c$require$$gOPD;


var $942e3d902bcc477c$exports = {};
'use strict';
/** @type {import('.')} */ var $942e3d902bcc477c$var$$defineProperty = Object.defineProperty || false;
if ($942e3d902bcc477c$var$$defineProperty) try {
    $942e3d902bcc477c$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $942e3d902bcc477c$var$$defineProperty = false;
}
$942e3d902bcc477c$exports = $942e3d902bcc477c$var$$defineProperty;


var $3a08f3b93b399588$var$throwTypeError = function() {
    throw new $e7333cdb62297eef$exports();
};
var $3a08f3b93b399588$var$ThrowTypeError = $5bccb8dbb44f329c$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $3a08f3b93b399588$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $5bccb8dbb44f329c$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $3a08f3b93b399588$var$throwTypeError;
        }
    }
}() : $3a08f3b93b399588$var$throwTypeError;

var $3a08f3b93b399588$var$hasSymbols = (parcelRequire("fa2Fq"))();
var $94794294face5b16$exports = {};
'use strict';
var $899ac815d4cac436$exports = {};
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ $899ac815d4cac436$exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;


var $43a51b504ad55992$exports = {};
'use strict';

/** @type {import('./Object.getPrototypeOf')} */ $43a51b504ad55992$exports = $780445d60a811bbf$exports.getPrototypeOf || null;


var $9d45d9abe8425603$exports = {};
'use strict';
var $fcaea5e35bd4de0e$exports = {};
'use strict';
var $10ce20d8d8e5d54c$exports = {};
'use strict';
var $ae424afb5f8fb4e2$exports = {};
'use strict';
/* eslint no-invalid-this: 1 */ var $ae424afb5f8fb4e2$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $ae424afb5f8fb4e2$var$toStr = Object.prototype.toString;
var $ae424afb5f8fb4e2$var$max = Math.max;
var $ae424afb5f8fb4e2$var$funcType = '[object Function]';
var $ae424afb5f8fb4e2$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $ae424afb5f8fb4e2$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $ae424afb5f8fb4e2$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
$ae424afb5f8fb4e2$exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $ae424afb5f8fb4e2$var$toStr.apply(target) !== $ae424afb5f8fb4e2$var$funcType) throw new TypeError($ae424afb5f8fb4e2$var$ERROR_MESSAGE + target);
    var args = $ae424afb5f8fb4e2$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $ae424afb5f8fb4e2$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $ae424afb5f8fb4e2$var$concatty(args, arguments));
    };
    var boundLength = $ae424afb5f8fb4e2$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $ae424afb5f8fb4e2$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$10ce20d8d8e5d54c$exports = Function.prototype.bind || $ae424afb5f8fb4e2$exports;



var $6e5da9480765f56a$exports = {};
'use strict';
/** @type {import('./functionCall')} */ $6e5da9480765f56a$exports = Function.prototype.call;


var $71c5865472d66679$exports = {};
'use strict';

var $367eed18337636b1$exports = {};
'use strict';
/** @type {import('./functionApply')} */ $367eed18337636b1$exports = Function.prototype.apply;



var $30f0eecf398cd57e$exports = {};
'use strict';
/** @type {import('./reflectApply')} */ $30f0eecf398cd57e$exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/** @type {import('./actualApply')} */ $71c5865472d66679$exports = $30f0eecf398cd57e$exports || $10ce20d8d8e5d54c$exports.call($6e5da9480765f56a$exports, $367eed18337636b1$exports);


/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ $fcaea5e35bd4de0e$exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $e7333cdb62297eef$exports('a function is required');
    return $71c5865472d66679$exports($10ce20d8d8e5d54c$exports, $6e5da9480765f56a$exports, args);
};



var $9d45d9abe8425603$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $9d45d9abe8425603$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $9d45d9abe8425603$var$desc = !!$9d45d9abe8425603$var$hasProtoAccessor && $5bccb8dbb44f329c$exports && $5bccb8dbb44f329c$exports(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $9d45d9abe8425603$var$$Object = Object;
var $9d45d9abe8425603$var$$getPrototypeOf = $9d45d9abe8425603$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $9d45d9abe8425603$exports = $9d45d9abe8425603$var$desc && typeof $9d45d9abe8425603$var$desc.get === 'function' ? $fcaea5e35bd4de0e$exports([
    $9d45d9abe8425603$var$desc.get
]) : typeof $9d45d9abe8425603$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $9d45d9abe8425603$var$$getPrototypeOf(value == null ? value : $9d45d9abe8425603$var$$Object(value));
} : false;


/** @type {import('.')} */ $94794294face5b16$exports = $899ac815d4cac436$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $899ac815d4cac436$exports(O);
} : $43a51b504ad55992$exports ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $43a51b504ad55992$exports(O);
} : $9d45d9abe8425603$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $9d45d9abe8425603$exports(O);
} : null;






var $3a08f3b93b399588$var$needsEval = {};
var $3a08f3b93b399588$var$TypedArray = typeof Uint8Array === 'undefined' || !$94794294face5b16$exports ? undefined : $94794294face5b16$exports(Uint8Array);
var $3a08f3b93b399588$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $94794294face5b16$exports ? $94794294face5b16$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $3a08f3b93b399588$var$needsEval,
    '%AsyncGenerator%': $3a08f3b93b399588$var$needsEval,
    '%AsyncGeneratorFunction%': $3a08f3b93b399588$var$needsEval,
    '%AsyncIteratorPrototype%': $3a08f3b93b399588$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $1eaffdb23035cbbb$exports,
    '%eval%': eval,
    '%EvalError%': $0a6c5e1d4184493e$exports,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $3a08f3b93b399588$var$$Function,
    '%GeneratorFunction%': $3a08f3b93b399588$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $94794294face5b16$exports ? $94794294face5b16$exports($94794294face5b16$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$3a08f3b93b399588$var$hasSymbols || !$94794294face5b16$exports ? undefined : $94794294face5b16$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $780445d60a811bbf$exports,
    '%Object.getOwnPropertyDescriptor%': $5bccb8dbb44f329c$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $7c5e8489cd9ea6b8$exports,
    '%ReferenceError%': $91d0feb9ab2312c1$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$3a08f3b93b399588$var$hasSymbols || !$94794294face5b16$exports ? undefined : $94794294face5b16$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $94794294face5b16$exports ? $94794294face5b16$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $3a08f3b93b399588$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $10c21afc31eb010f$exports,
    '%ThrowTypeError%': $3a08f3b93b399588$var$ThrowTypeError,
    '%TypedArray%': $3a08f3b93b399588$var$TypedArray,
    '%TypeError%': $e7333cdb62297eef$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $507a2ecfb86dffac$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $6e5da9480765f56a$exports,
    '%Function.prototype.apply%': $367eed18337636b1$exports,
    '%Object.defineProperty%': $942e3d902bcc477c$exports,
    '%Object.getPrototypeOf%': $43a51b504ad55992$exports,
    '%Math.abs%': $249e1f48341b5c56$exports,
    '%Math.floor%': $d9a7a967efd8a30b$exports,
    '%Math.max%': $a2741222432daf91$exports,
    '%Math.min%': $d37082e020955214$exports,
    '%Math.pow%': $cd8c11561a2c9634$exports,
    '%Math.round%': $c2fb0e7b524e938f$exports,
    '%Math.sign%': $63832c8987979246$exports,
    '%Reflect.getPrototypeOf%': $899ac815d4cac436$exports
};
if ($94794294face5b16$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $3a08f3b93b399588$var$errorProto = $94794294face5b16$exports($94794294face5b16$exports(e));
    $3a08f3b93b399588$var$INTRINSICS['%Error.prototype%'] = $3a08f3b93b399588$var$errorProto;
}
var $3a08f3b93b399588$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $94794294face5b16$exports) value = $94794294face5b16$exports(gen.prototype);
    }
    $3a08f3b93b399588$var$INTRINSICS[name] = value;
    return value;
};
var $3a08f3b93b399588$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $73b0de3d2e3453fc$exports = {};
'use strict';
var $73b0de3d2e3453fc$var$call = Function.prototype.call;
var $73b0de3d2e3453fc$var$$hasOwn = Object.prototype.hasOwnProperty;

/** @type {import('.')} */ $73b0de3d2e3453fc$exports = $10ce20d8d8e5d54c$exports.call($73b0de3d2e3453fc$var$call, $73b0de3d2e3453fc$var$$hasOwn);


var $3a08f3b93b399588$var$$concat = $10ce20d8d8e5d54c$exports.call($6e5da9480765f56a$exports, Array.prototype.concat);
var $3a08f3b93b399588$var$$spliceApply = $10ce20d8d8e5d54c$exports.call($367eed18337636b1$exports, Array.prototype.splice);
var $3a08f3b93b399588$var$$replace = $10ce20d8d8e5d54c$exports.call($6e5da9480765f56a$exports, String.prototype.replace);
var $3a08f3b93b399588$var$$strSlice = $10ce20d8d8e5d54c$exports.call($6e5da9480765f56a$exports, String.prototype.slice);
var $3a08f3b93b399588$var$$exec = $10ce20d8d8e5d54c$exports.call($6e5da9480765f56a$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $3a08f3b93b399588$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $3a08f3b93b399588$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $3a08f3b93b399588$var$stringToPath = function stringToPath(string) {
    var first = $3a08f3b93b399588$var$$strSlice(string, 0, 1);
    var last = $3a08f3b93b399588$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $10c21afc31eb010f$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $10c21afc31eb010f$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $3a08f3b93b399588$var$$replace(string, $3a08f3b93b399588$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $3a08f3b93b399588$var$$replace(subString, $3a08f3b93b399588$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $3a08f3b93b399588$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($73b0de3d2e3453fc$exports($3a08f3b93b399588$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $3a08f3b93b399588$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($73b0de3d2e3453fc$exports($3a08f3b93b399588$var$INTRINSICS, intrinsicName)) {
        var value = $3a08f3b93b399588$var$INTRINSICS[intrinsicName];
        if (value === $3a08f3b93b399588$var$needsEval) value = $3a08f3b93b399588$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $e7333cdb62297eef$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $10c21afc31eb010f$exports('intrinsic ' + name + ' does not exist!');
};
$3a08f3b93b399588$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $e7333cdb62297eef$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $e7333cdb62297eef$exports('"allowMissing" argument must be a boolean');
    if ($3a08f3b93b399588$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $10c21afc31eb010f$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $3a08f3b93b399588$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $3a08f3b93b399588$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $3a08f3b93b399588$var$$spliceApply(parts, $3a08f3b93b399588$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $3a08f3b93b399588$var$$strSlice(part, 0, 1);
        var last = $3a08f3b93b399588$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $10c21afc31eb010f$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($73b0de3d2e3453fc$exports($3a08f3b93b399588$var$INTRINSICS, intrinsicRealName)) value = $3a08f3b93b399588$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $e7333cdb62297eef$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($5bccb8dbb44f329c$exports && i + 1 >= parts.length) {
                var desc = $5bccb8dbb44f329c$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $73b0de3d2e3453fc$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $3a08f3b93b399588$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $a95c7e6883bd7de8$exports = {};
'use strict';


/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $a95c7e6883bd7de8$var$$indexOf = $fcaea5e35bd4de0e$exports([
    $3a08f3b93b399588$exports('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ $a95c7e6883bd7de8$exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $3a08f3b93b399588$exports(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $a95c7e6883bd7de8$var$$indexOf(name, '.prototype.') > -1) return $fcaea5e35bd4de0e$exports(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};




var $005dee0701e4a773$var$$Map = $3a08f3b93b399588$exports('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $005dee0701e4a773$var$$mapGet = $a95c7e6883bd7de8$exports('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $005dee0701e4a773$var$$mapSet = $a95c7e6883bd7de8$exports('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $005dee0701e4a773$var$$mapHas = $a95c7e6883bd7de8$exports('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $005dee0701e4a773$var$$mapDelete = $a95c7e6883bd7de8$exports('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $005dee0701e4a773$var$$mapSize = $a95c7e6883bd7de8$exports('Map.prototype.size', true);
/** @type {import('.')} */ $005dee0701e4a773$exports = !!$005dee0701e4a773$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $e7333cdb62297eef$exports('Side channel does not contain ' + $099e73f2f1d394e5$exports(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $005dee0701e4a773$var$$mapDelete($m, key);
                if ($005dee0701e4a773$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $005dee0701e4a773$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $005dee0701e4a773$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $005dee0701e4a773$var$$Map();
            $005dee0701e4a773$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};


var $62877eb4813076bf$exports = {};
'use strict';





var $62877eb4813076bf$var$$WeakMap = $3a08f3b93b399588$exports('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $62877eb4813076bf$var$$weakMapGet = $a95c7e6883bd7de8$exports('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $62877eb4813076bf$var$$weakMapSet = $a95c7e6883bd7de8$exports('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $62877eb4813076bf$var$$weakMapHas = $a95c7e6883bd7de8$exports('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $62877eb4813076bf$var$$weakMapDelete = $a95c7e6883bd7de8$exports('WeakMap.prototype.delete', true);
/** @type {import('.')} */ $62877eb4813076bf$exports = $62877eb4813076bf$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $e7333cdb62297eef$exports('Side channel does not contain ' + $099e73f2f1d394e5$exports(key));
        },
        'delete': function(key) {
            if ($62877eb4813076bf$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $62877eb4813076bf$var$$weakMapDelete($wm, key);
            } else if ($005dee0701e4a773$exports) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($62877eb4813076bf$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $62877eb4813076bf$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($62877eb4813076bf$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $62877eb4813076bf$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($62877eb4813076bf$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $62877eb4813076bf$var$$WeakMap();
                $62877eb4813076bf$var$$weakMapSet($wm, key, value);
            } else if ($005dee0701e4a773$exports) {
                if (!$m) $m = $005dee0701e4a773$exports();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $005dee0701e4a773$exports;


var $5bb37b4834f07dfc$var$makeChannel = $62877eb4813076bf$exports || $005dee0701e4a773$exports || $6fb86cf97df15c41$exports;
/** @type {import('.')} */ $5bb37b4834f07dfc$exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $e7333cdb62297eef$exports('Side channel does not contain ' + $099e73f2f1d394e5$exports(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $5bb37b4834f07dfc$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $1a91bed07bebc65f$exports = {};
'use strict';
var $c47be5eca039a4d0$exports = {};
'use strict';
var $c47be5eca039a4d0$var$replace = String.prototype.replace;
var $c47be5eca039a4d0$var$percentTwenties = /%20/g;
var $c47be5eca039a4d0$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$c47be5eca039a4d0$exports = {
    'default': $c47be5eca039a4d0$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $c47be5eca039a4d0$var$replace.call(value, $c47be5eca039a4d0$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $c47be5eca039a4d0$var$Format.RFC1738,
    RFC3986: $c47be5eca039a4d0$var$Format.RFC3986
};


var $1a91bed07bebc65f$var$has = Object.prototype.hasOwnProperty;
var $1a91bed07bebc65f$var$isArray = Array.isArray;
var $1a91bed07bebc65f$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $1a91bed07bebc65f$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($1a91bed07bebc65f$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $1a91bed07bebc65f$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $1a91bed07bebc65f$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($1a91bed07bebc65f$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$1a91bed07bebc65f$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($1a91bed07bebc65f$var$isArray(target) && !$1a91bed07bebc65f$var$isArray(source)) mergeTarget = $1a91bed07bebc65f$var$arrayToObject(target, options);
    if ($1a91bed07bebc65f$var$isArray(target) && $1a91bed07bebc65f$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($1a91bed07bebc65f$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($1a91bed07bebc65f$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $1a91bed07bebc65f$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $1a91bed07bebc65f$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $1a91bed07bebc65f$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $1a91bed07bebc65f$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $1a91bed07bebc65f$var$limit){
        var segment = string.length >= $1a91bed07bebc65f$var$limit ? string.slice(j, j + $1a91bed07bebc65f$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $c47be5eca039a4d0$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $1a91bed07bebc65f$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $1a91bed07bebc65f$var$hexTable[0xC0 | c >> 6] + $1a91bed07bebc65f$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $1a91bed07bebc65f$var$hexTable[0xE0 | c >> 12] + $1a91bed07bebc65f$var$hexTable[0x80 | c >> 6 & 0x3F] + $1a91bed07bebc65f$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $1a91bed07bebc65f$var$hexTable[0xF0 | c >> 18] + $1a91bed07bebc65f$var$hexTable[0x80 | c >> 12 & 0x3F] + $1a91bed07bebc65f$var$hexTable[0x80 | c >> 6 & 0x3F] + $1a91bed07bebc65f$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $1a91bed07bebc65f$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $1a91bed07bebc65f$var$compactQueue(queue);
    return value;
};
var $1a91bed07bebc65f$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $1a91bed07bebc65f$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $1a91bed07bebc65f$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $1a91bed07bebc65f$var$maybeMap = function maybeMap(val, fn) {
    if ($1a91bed07bebc65f$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$1a91bed07bebc65f$exports = {
    arrayToObject: $1a91bed07bebc65f$var$arrayToObject,
    assign: $1a91bed07bebc65f$var$assign,
    combine: $1a91bed07bebc65f$var$combine,
    compact: $1a91bed07bebc65f$var$compact,
    decode: $1a91bed07bebc65f$var$decode,
    encode: $1a91bed07bebc65f$var$encode,
    isBuffer: $1a91bed07bebc65f$var$isBuffer,
    isRegExp: $1a91bed07bebc65f$var$isRegExp,
    maybeMap: $1a91bed07bebc65f$var$maybeMap,
    merge: $1a91bed07bebc65f$var$merge
};



var $4e0981a8baadc926$var$has = Object.prototype.hasOwnProperty;
var $4e0981a8baadc926$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $4e0981a8baadc926$var$isArray = Array.isArray;
var $4e0981a8baadc926$var$push = Array.prototype.push;
var $4e0981a8baadc926$var$pushToArray = function(arr, valueOrArray) {
    $4e0981a8baadc926$var$push.apply(arr, $4e0981a8baadc926$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $4e0981a8baadc926$var$toISO = Date.prototype.toISOString;
var $4e0981a8baadc926$var$defaultFormat = $c47be5eca039a4d0$exports.default;
var $4e0981a8baadc926$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $1a91bed07bebc65f$exports.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $4e0981a8baadc926$var$defaultFormat,
    formatter: $c47be5eca039a4d0$exports.formatters[$4e0981a8baadc926$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $4e0981a8baadc926$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $4e0981a8baadc926$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $4e0981a8baadc926$var$sentinel = {};
var $4e0981a8baadc926$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($4e0981a8baadc926$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($4e0981a8baadc926$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $4e0981a8baadc926$var$isArray(obj)) obj = $1a91bed07bebc65f$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $4e0981a8baadc926$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($4e0981a8baadc926$var$isNonNullishPrimitive(obj) || $1a91bed07bebc65f$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $4e0981a8baadc926$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $4e0981a8baadc926$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $4e0981a8baadc926$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $1a91bed07bebc65f$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($4e0981a8baadc926$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $4e0981a8baadc926$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $4e0981a8baadc926$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $4e0981a8baadc926$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $5bb37b4834f07dfc$exports();
        valueSideChannel.set($4e0981a8baadc926$var$sentinel, sideChannel);
        $4e0981a8baadc926$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $4e0981a8baadc926$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $4e0981a8baadc926$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $4e0981a8baadc926$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $4e0981a8baadc926$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $c47be5eca039a4d0$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$4e0981a8baadc926$var$has.call($c47be5eca039a4d0$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $c47be5eca039a4d0$exports.formatters[format];
    var filter = $4e0981a8baadc926$var$defaults.filter;
    if (typeof opts.filter === 'function' || $4e0981a8baadc926$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $4e0981a8baadc926$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $4e0981a8baadc926$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $4e0981a8baadc926$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $4e0981a8baadc926$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $4e0981a8baadc926$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $4e0981a8baadc926$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $4e0981a8baadc926$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $4e0981a8baadc926$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $4e0981a8baadc926$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $4e0981a8baadc926$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $4e0981a8baadc926$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $4e0981a8baadc926$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $4e0981a8baadc926$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $4e0981a8baadc926$var$defaults.strictNullHandling
    };
};
$4e0981a8baadc926$exports = function(object, opts) {
    var obj = object;
    var options = $4e0981a8baadc926$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($4e0981a8baadc926$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $4e0981a8baadc926$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $5bb37b4834f07dfc$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $4e0981a8baadc926$var$pushToArray(keys, $4e0981a8baadc926$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $83d08a0b4b41a3cb$exports = {};
'use strict';

var $83d08a0b4b41a3cb$var$has = Object.prototype.hasOwnProperty;
var $83d08a0b4b41a3cb$var$isArray = Array.isArray;
var $83d08a0b4b41a3cb$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $1a91bed07bebc65f$exports.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $83d08a0b4b41a3cb$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $83d08a0b4b41a3cb$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $83d08a0b4b41a3cb$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $83d08a0b4b41a3cb$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $83d08a0b4b41a3cb$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $83d08a0b4b41a3cb$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $83d08a0b4b41a3cb$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $83d08a0b4b41a3cb$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $83d08a0b4b41a3cb$var$defaults.decoder, charset, 'key');
            val = $1a91bed07bebc65f$exports.maybeMap($83d08a0b4b41a3cb$var$parseArrayValue(part.slice(pos + 1), options, $83d08a0b4b41a3cb$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $83d08a0b4b41a3cb$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $83d08a0b4b41a3cb$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $83d08a0b4b41a3cb$var$isArray(val) ? [
            val
        ] : val;
        var existing = $83d08a0b4b41a3cb$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $1a91bed07bebc65f$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $83d08a0b4b41a3cb$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $83d08a0b4b41a3cb$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $1a91bed07bebc65f$exports.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $83d08a0b4b41a3cb$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $83d08a0b4b41a3cb$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $83d08a0b4b41a3cb$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $83d08a0b4b41a3cb$var$parseObject(keys, val, options, valuesParsed);
};
var $83d08a0b4b41a3cb$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $83d08a0b4b41a3cb$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $83d08a0b4b41a3cb$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $83d08a0b4b41a3cb$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $83d08a0b4b41a3cb$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $83d08a0b4b41a3cb$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $83d08a0b4b41a3cb$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $83d08a0b4b41a3cb$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $83d08a0b4b41a3cb$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $83d08a0b4b41a3cb$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $83d08a0b4b41a3cb$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $83d08a0b4b41a3cb$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $83d08a0b4b41a3cb$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $1a91bed07bebc65f$exports.isRegExp(opts.delimiter) ? opts.delimiter : $83d08a0b4b41a3cb$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $83d08a0b4b41a3cb$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $83d08a0b4b41a3cb$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $83d08a0b4b41a3cb$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $83d08a0b4b41a3cb$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $83d08a0b4b41a3cb$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $83d08a0b4b41a3cb$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
$83d08a0b4b41a3cb$exports = function(str, opts) {
    var options = $83d08a0b4b41a3cb$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $83d08a0b4b41a3cb$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $83d08a0b4b41a3cb$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $1a91bed07bebc65f$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $1a91bed07bebc65f$exports.compact(obj);
};



$358d0673515ab87d$exports = {
    formats: $c47be5eca039a4d0$exports,
    parse: $83d08a0b4b41a3cb$exports,
    stringify: $4e0981a8baadc926$exports
};


var $ac1dc4345d36ffa4$exports = {};
"use strict";
function $ac1dc4345d36ffa4$var$getWindowHash() {
    return window.location.hash.substr(1);
}
function $ac1dc4345d36ffa4$var$removeHash() {
    history.pushState("", document.title, window.location.pathname + window.location.search);
}
function $ac1dc4345d36ffa4$var$setWindowHash(e) {
    if (!e || "#" === e) return void $ac1dc4345d36ffa4$var$removeHash();
    window.location.hash = e;
}
function $ac1dc4345d36ffa4$var$parseQuery(e) {
    var t = e ? e.split("&") : [], r = {};
    return t.forEach(function(e) {
        var t = e.split("="), n = decodeURIComponent(t[0]);
        if (n) {
            var o = decodeURIComponent(t[1]);
            r[n] = o;
        }
    }), r;
}
function $ac1dc4345d36ffa4$var$prepareQuery(e) {
    var t = "";
    for(var r in e)if (r) {
        var n = e[r];
        t += "&" + encodeURIComponent(r) + "=" + encodeURIComponent(n);
    }
    return t.substr(1);
}
function $ac1dc4345d36ffa4$var$get(e) {
    return $ac1dc4345d36ffa4$var$parseQuery($ac1dc4345d36ffa4$var$getWindowHash())[e];
}
function $ac1dc4345d36ffa4$var$set4Href(e, t) {
    var r = $ac1dc4345d36ffa4$var$getWindowHash(), n = $ac1dc4345d36ffa4$var$parseQuery(r);
    return n[e] = t, "#" + $ac1dc4345d36ffa4$var$prepareQuery(n);
}
function $ac1dc4345d36ffa4$var$set(e, t) {
    $ac1dc4345d36ffa4$var$setWindowHash($ac1dc4345d36ffa4$var$set4Href(e, t));
}
function $ac1dc4345d36ffa4$var$del4Href(e) {
    var t = $ac1dc4345d36ffa4$var$getWindowHash(), r = $ac1dc4345d36ffa4$var$parseQuery(t);
    return delete r[e], "#" + $ac1dc4345d36ffa4$var$prepareQuery(r);
}
function $ac1dc4345d36ffa4$var$del(e) {
    $ac1dc4345d36ffa4$var$setWindowHash($ac1dc4345d36ffa4$var$del4Href(e));
}
Object.defineProperty($ac1dc4345d36ffa4$exports, "__esModule", {
    value: !0
}), $ac1dc4345d36ffa4$exports.get = $ac1dc4345d36ffa4$var$get, $ac1dc4345d36ffa4$exports.set4Href = $ac1dc4345d36ffa4$var$set4Href, $ac1dc4345d36ffa4$exports.set = $ac1dc4345d36ffa4$var$set, $ac1dc4345d36ffa4$exports.del4Href = $ac1dc4345d36ffa4$var$del4Href, $ac1dc4345d36ffa4$exports.del = $ac1dc4345d36ffa4$var$del;




const $4ddc8df16bccfebf$export$840ef5c626b2833e = (0, $9d72a09537a5cbc3$export$fd42f52fd3ae1109)({});
const $4ddc8df16bccfebf$export$748e303ef81f8503 = (0, $9d72a09537a5cbc3$export$fd42f52fd3ae1109)({});
const $4ddc8df16bccfebf$export$54335253c59b49ae = (0, $9d72a09537a5cbc3$export$fd42f52fd3ae1109)({
    face: ()=>undefined,
    rib: ()=>undefined,
    strategies: ()=>undefined
});



function $448fcf004b3856ad$export$c8424c4d8ba2150() {
    const version = "9a3b656c1eb05f373297d1bff3189a1fdbba561f";
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $9d72a09537a5cbc3$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("h1", null, "About NDNts NFD Status Page"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("ul", {
        style: "line-height:2em;"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
        href: "https://yoursunny.com/p/NDNts/NFD-status-page/"
    }, "Project Homepage")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
        href: "https://github.com/yoursunny/NDNts-NFD-status-page"
    }, "GitHub repository")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("li", null, "NDNts NFD Status Page version ", version), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("li", null, "Powered by ", /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
        href: "https://yoursunny.com/p/NDNts/"
    }, "NDNts"), " and modern web technologies")));
}



const $7b9ec0f3acd24c1c$var$toZeroIfInfinity = (value)=>Number.isFinite(value) ? value : 0;
function $7b9ec0f3acd24c1c$var$parseNumber(milliseconds) {
    return {
        days: Math.trunc(milliseconds / 86400000),
        hours: Math.trunc(milliseconds / 3600000 % 24),
        minutes: Math.trunc(milliseconds / 60000 % 60),
        seconds: Math.trunc(milliseconds / 1000 % 60),
        milliseconds: Math.trunc(milliseconds % 1000),
        microseconds: Math.trunc($7b9ec0f3acd24c1c$var$toZeroIfInfinity(milliseconds * 1000) % 1000),
        nanoseconds: Math.trunc($7b9ec0f3acd24c1c$var$toZeroIfInfinity(milliseconds * 1e6) % 1000)
    };
}
function $7b9ec0f3acd24c1c$var$parseBigint(milliseconds) {
    return {
        days: milliseconds / 86400000n,
        hours: milliseconds / 3600000n % 24n,
        minutes: milliseconds / 60000n % 60n,
        seconds: milliseconds / 1000n % 60n,
        milliseconds: milliseconds % 1000n,
        microseconds: 0n,
        nanoseconds: 0n
    };
}
function $7b9ec0f3acd24c1c$export$2e2bcd8739ae039(milliseconds) {
    switch(typeof milliseconds){
        case 'number':
            if (Number.isFinite(milliseconds)) return $7b9ec0f3acd24c1c$var$parseNumber(milliseconds);
            break;
        case 'bigint':
            return $7b9ec0f3acd24c1c$var$parseBigint(milliseconds);
    }
    throw new TypeError('Expected a finite number or bigint');
}


const $32fa34047bfe5216$var$isZero = (value)=>value === 0 || value === 0n;
const $32fa34047bfe5216$var$pluralize = (word, count)=>count === 1 || count === 1n ? word : `${word}s`;
const $32fa34047bfe5216$var$SECOND_ROUNDING_EPSILON = 0.0000001;
const $32fa34047bfe5216$var$ONE_DAY_IN_MILLISECONDS = 24n * 60n * 60n * 1000n;
function $32fa34047bfe5216$export$2e2bcd8739ae039(milliseconds, options) {
    const isBigInt = typeof milliseconds === 'bigint';
    if (!isBigInt && !Number.isFinite(milliseconds)) throw new TypeError('Expected a finite number or bigint');
    options = {
        ...options
    };
    const sign = milliseconds < 0 ? '-' : '';
    milliseconds = milliseconds < 0 ? -milliseconds : milliseconds; // Cannot use `Math.abs()` because of BigInt support.
    if (options.colonNotation) {
        options.compact = false;
        options.formatSubMilliseconds = false;
        options.separateMilliseconds = false;
        options.verbose = false;
    }
    if (options.compact) {
        options.unitCount = 1;
        options.secondsDecimalDigits = 0;
        options.millisecondsDecimalDigits = 0;
    }
    let result = [];
    const floorDecimals = (value, decimalDigits)=>{
        const flooredInterimValue = Math.floor(value * 10 ** decimalDigits + $32fa34047bfe5216$var$SECOND_ROUNDING_EPSILON);
        const flooredValue = Math.round(flooredInterimValue) / 10 ** decimalDigits;
        return flooredValue.toFixed(decimalDigits);
    };
    const add = (value, long, short, valueString)=>{
        if ((result.length === 0 || !options.colonNotation) && $32fa34047bfe5216$var$isZero(value) && !(options.colonNotation && short === 'm')) return;
        valueString ??= String(value);
        if (options.colonNotation) {
            const wholeDigits = valueString.includes('.') ? valueString.split('.')[0].length : valueString.length;
            const minLength = result.length > 0 ? 2 : 1;
            valueString = '0'.repeat(Math.max(0, minLength - wholeDigits)) + valueString;
        } else valueString += options.verbose ? ' ' + $32fa34047bfe5216$var$pluralize(long, value) : short;
        result.push(valueString);
    };
    const parsed = (0, $7b9ec0f3acd24c1c$export$2e2bcd8739ae039)(milliseconds);
    const days = BigInt(parsed.days);
    if (options.hideYearAndDays) add(BigInt(days) * 24n + BigInt(parsed.hours), 'hour', 'h');
    else {
        if (options.hideYear) add(days, 'day', 'd');
        else {
            add(days / 365n, 'year', 'y');
            add(days % 365n, 'day', 'd');
        }
        add(Number(parsed.hours), 'hour', 'h');
    }
    add(Number(parsed.minutes), 'minute', 'm');
    if (!options.hideSeconds) {
        if (options.separateMilliseconds || options.formatSubMilliseconds || !options.colonNotation && milliseconds < 1000) {
            const seconds = Number(parsed.seconds);
            const milliseconds = Number(parsed.milliseconds);
            const microseconds = Number(parsed.microseconds);
            const nanoseconds = Number(parsed.nanoseconds);
            add(seconds, 'second', 's');
            if (options.formatSubMilliseconds) {
                add(milliseconds, 'millisecond', 'ms');
                add(microseconds, 'microsecond', "\xb5s");
                add(nanoseconds, 'nanosecond', 'ns');
            } else {
                const millisecondsAndBelow = milliseconds + microseconds / 1000 + nanoseconds / 1e6;
                const millisecondsDecimalDigits = typeof options.millisecondsDecimalDigits === 'number' ? options.millisecondsDecimalDigits : 0;
                const roundedMilliseconds = millisecondsAndBelow >= 1 ? Math.round(millisecondsAndBelow) : Math.ceil(millisecondsAndBelow);
                const millisecondsString = millisecondsDecimalDigits ? millisecondsAndBelow.toFixed(millisecondsDecimalDigits) : roundedMilliseconds;
                add(Number.parseFloat(millisecondsString), 'millisecond', 'ms', millisecondsString);
            }
        } else {
            const seconds = (isBigInt ? Number(milliseconds % $32fa34047bfe5216$var$ONE_DAY_IN_MILLISECONDS) : milliseconds) / 1000 % 60;
            const secondsDecimalDigits = typeof options.secondsDecimalDigits === 'number' ? options.secondsDecimalDigits : 1;
            const secondsFixed = floorDecimals(seconds, secondsDecimalDigits);
            const secondsString = options.keepDecimalsOnWholeSeconds ? secondsFixed : secondsFixed.replace(/\.0+$/, '');
            add(Number.parseFloat(secondsString), 'second', 's', secondsString);
        }
    }
    if (result.length === 0) return sign + '0' + (options.verbose ? ' milliseconds' : 'ms');
    const separator = options.colonNotation ? ':' : ' ';
    if (typeof options.unitCount === 'number') result = result.slice(0, Math.max(options.unitCount, 1));
    return sign + result.join(separator);
}


function $70b7288ce14ac696$export$a06f1c675e846f6f({ requests: { host: host, interval: interval } }) {
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("footer", {
        class: "pure-g"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-u-1"
    }, "NDNts NFD status page,", " ", host, ", refreshing every ", (0, $32fa34047bfe5216$export$2e2bcd8739ae039)(interval)));
}



class $80199810cc459725$export$1f9ff5f4a6c9361a extends (0, $9d72a09537a5cbc3$export$16fa2f45be04daa8) {
    render() {
        const { show: show, children: children } = this.props;
        return show ? children : undefined;
    }
}




var $852a55cf17d8b19d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($852a55cf17d8b19d$exports) {
        classNames.default = classNames;
        $852a55cf17d8b19d$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



class $21f3feca442f8f00$export$a6edb1992047cc25 extends (0, $9d72a09537a5cbc3$export$16fa2f45be04daa8) {
    render() {
        const { tabs: tabs, selected: selected, onChange: onChange, children: children } = this.props;
        return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("nav", {
            class: "pure-menu pure-menu-horizontal",
            style: {
                paddingBottom: "1ex"
            }
        }, children, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("ul", {
            class: "pure-menu-list"
        }, tabs.map((tab)=>/*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("li", {
                key: tab,
                class: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("pure-menu-item", {
                    "pure-menu-selected": tab === selected
                })
            }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
                href: "#",
                class: "pure-menu-link",
                onClick: (evt)=>{
                    evt.preventDefault();
                    onChange?.(tab);
                }
            }, tab)))));
    }
}


function $184d2ccc27df5fc4$export$669f6ea7d267feaf({ requests: requests }) {
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $9d72a09537a5cbc3$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-g"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-u-1"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $21f3feca442f8f00$export$a6edb1992047cc25), {
        tabs: []
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("span", {
        class: "pure-menu-heading"
    }, "NFD Status Page")))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-g"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("section", {
        class: "pure-u-1"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("h1", null, "Loading ", requests.uri))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $70b7288ce14ac696$export$a06f1c675e846f6f), {
        requests: requests
    }));
}





var $1fdd316a03abfa38$var$t, $1fdd316a03abfa38$var$r, $1fdd316a03abfa38$var$u, $1fdd316a03abfa38$var$i, $1fdd316a03abfa38$var$o = 0, $1fdd316a03abfa38$var$f = [], $1fdd316a03abfa38$var$c = (0, $9d72a09537a5cbc3$export$41c562ebe57d11e2), $1fdd316a03abfa38$var$e = $1fdd316a03abfa38$var$c.__b, $1fdd316a03abfa38$var$a = $1fdd316a03abfa38$var$c.__r, $1fdd316a03abfa38$var$v = $1fdd316a03abfa38$var$c.diffed, $1fdd316a03abfa38$var$l = $1fdd316a03abfa38$var$c.__c, $1fdd316a03abfa38$var$m = $1fdd316a03abfa38$var$c.unmount, $1fdd316a03abfa38$var$s = $1fdd316a03abfa38$var$c.__;
function $1fdd316a03abfa38$var$p(n, t) {
    $1fdd316a03abfa38$var$c.__h && $1fdd316a03abfa38$var$c.__h($1fdd316a03abfa38$var$r, n, $1fdd316a03abfa38$var$o || t), $1fdd316a03abfa38$var$o = 0;
    var u = $1fdd316a03abfa38$var$r.__H || ($1fdd316a03abfa38$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $1fdd316a03abfa38$export$60241385465d0a34(n) {
    return $1fdd316a03abfa38$var$o = 1, $1fdd316a03abfa38$export$13e3392192263954($1fdd316a03abfa38$var$D, n);
}
function $1fdd316a03abfa38$export$13e3392192263954(n, u, i) {
    var o = $1fdd316a03abfa38$var$p($1fdd316a03abfa38$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $1fdd316a03abfa38$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $1fdd316a03abfa38$var$r, !$1fdd316a03abfa38$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $1fdd316a03abfa38$var$r.__f = !0;
        var c = $1fdd316a03abfa38$var$r.shouldComponentUpdate, e = $1fdd316a03abfa38$var$r.componentWillUpdate;
        $1fdd316a03abfa38$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $1fdd316a03abfa38$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $1fdd316a03abfa38$export$6d9c69b0de29b591(n, u) {
    var i = $1fdd316a03abfa38$var$p($1fdd316a03abfa38$var$t++, 3);
    !$1fdd316a03abfa38$var$c.__s && $1fdd316a03abfa38$var$C(i.__H, u) && (i.__ = n, i.u = u, $1fdd316a03abfa38$var$r.__H.__h.push(i));
}
function $1fdd316a03abfa38$export$e5c5a5f917a5871c(n, u) {
    var i = $1fdd316a03abfa38$var$p($1fdd316a03abfa38$var$t++, 4);
    !$1fdd316a03abfa38$var$c.__s && $1fdd316a03abfa38$var$C(i.__H, u) && (i.__ = n, i.u = u, $1fdd316a03abfa38$var$r.__h.push(i));
}
function $1fdd316a03abfa38$export$b8f5890fc79d6aca(n) {
    return $1fdd316a03abfa38$var$o = 5, $1fdd316a03abfa38$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $1fdd316a03abfa38$export$d5a552a76deda3c2(n, t, r) {
    $1fdd316a03abfa38$var$o = 6, $1fdd316a03abfa38$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $1fdd316a03abfa38$export$1538c33de8887b59(n, r) {
    var u = $1fdd316a03abfa38$var$p($1fdd316a03abfa38$var$t++, 7);
    return $1fdd316a03abfa38$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $1fdd316a03abfa38$export$35808ee640e87ca7(n, t) {
    return $1fdd316a03abfa38$var$o = 8, $1fdd316a03abfa38$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $1fdd316a03abfa38$export$fae74005e78b1a27(n) {
    var u = $1fdd316a03abfa38$var$r.context[n.__c], i = $1fdd316a03abfa38$var$p($1fdd316a03abfa38$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($1fdd316a03abfa38$var$r)), u.props.value) : n.__;
}
function $1fdd316a03abfa38$export$dc8fbce3eb94dc1e(n, t) {
    $1fdd316a03abfa38$var$c.useDebugValue && $1fdd316a03abfa38$var$c.useDebugValue(t ? t(n) : n);
}
function $1fdd316a03abfa38$export$c052f6604b7d51fe(n) {
    var u = $1fdd316a03abfa38$var$p($1fdd316a03abfa38$var$t++, 10), i = $1fdd316a03abfa38$export$60241385465d0a34();
    return u.__ = n, $1fdd316a03abfa38$var$r.componentDidCatch || ($1fdd316a03abfa38$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $1fdd316a03abfa38$export$f680877a34711e37() {
    var n = $1fdd316a03abfa38$var$p($1fdd316a03abfa38$var$t++, 11);
    if (!n.__) {
        for(var u = $1fdd316a03abfa38$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $1fdd316a03abfa38$var$j() {
    for(var n; n = $1fdd316a03abfa38$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($1fdd316a03abfa38$var$z), n.__H.__h.forEach($1fdd316a03abfa38$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $1fdd316a03abfa38$var$c.__e(t, n.__v);
    }
}
$1fdd316a03abfa38$var$c.__b = function(n) {
    $1fdd316a03abfa38$var$r = null, $1fdd316a03abfa38$var$e && $1fdd316a03abfa38$var$e(n);
}, $1fdd316a03abfa38$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $1fdd316a03abfa38$var$s && $1fdd316a03abfa38$var$s(n, t);
}, $1fdd316a03abfa38$var$c.__r = function(n) {
    $1fdd316a03abfa38$var$a && $1fdd316a03abfa38$var$a(n), $1fdd316a03abfa38$var$t = 0;
    var i = ($1fdd316a03abfa38$var$r = n.__c).__H;
    i && ($1fdd316a03abfa38$var$u === $1fdd316a03abfa38$var$r ? (i.__h = [], $1fdd316a03abfa38$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($1fdd316a03abfa38$var$z), i.__h.forEach($1fdd316a03abfa38$var$B), i.__h = [], $1fdd316a03abfa38$var$t = 0)), $1fdd316a03abfa38$var$u = $1fdd316a03abfa38$var$r;
}, $1fdd316a03abfa38$var$c.diffed = function(n) {
    $1fdd316a03abfa38$var$v && $1fdd316a03abfa38$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $1fdd316a03abfa38$var$f.push(t) && $1fdd316a03abfa38$var$i === $1fdd316a03abfa38$var$c.requestAnimationFrame || (($1fdd316a03abfa38$var$i = $1fdd316a03abfa38$var$c.requestAnimationFrame) || $1fdd316a03abfa38$var$w)($1fdd316a03abfa38$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $1fdd316a03abfa38$var$u = $1fdd316a03abfa38$var$r = null;
}, $1fdd316a03abfa38$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($1fdd316a03abfa38$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $1fdd316a03abfa38$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $1fdd316a03abfa38$var$c.__e(r, n.__v);
        }
    }), $1fdd316a03abfa38$var$l && $1fdd316a03abfa38$var$l(n, t);
}, $1fdd316a03abfa38$var$c.unmount = function(n) {
    $1fdd316a03abfa38$var$m && $1fdd316a03abfa38$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $1fdd316a03abfa38$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $1fdd316a03abfa38$var$c.__e(t, r.__v));
};
var $1fdd316a03abfa38$var$k = "function" == typeof requestAnimationFrame;
function $1fdd316a03abfa38$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $1fdd316a03abfa38$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $1fdd316a03abfa38$var$k && (t = requestAnimationFrame(r));
}
function $1fdd316a03abfa38$var$z(n) {
    var t = $1fdd316a03abfa38$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $1fdd316a03abfa38$var$r = t;
}
function $1fdd316a03abfa38$var$B(n) {
    var t = $1fdd316a03abfa38$var$r;
    n.__c = n.__(), $1fdd316a03abfa38$var$r = t;
}
function $1fdd316a03abfa38$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $1fdd316a03abfa38$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}




const $dca48e99102f4a59$export$c506431d6b27243b = {
    Name: 0x07,
    GenericNameComponent: 0x08,
    ImplicitSha256DigestComponent: 0x01,
    ParametersSha256DigestComponent: 0x02,
    Interest: 0x05,
    CanBePrefix: 0x21,
    MustBeFresh: 0x12,
    ForwardingHint: 0x1E,
    Nonce: 0x0A,
    InterestLifetime: 0x0C,
    HopLimit: 0x22,
    AppParameters: 0x24,
    ISigInfo: 0x2C,
    ISigValue: 0x2E,
    Data: 0x06,
    MetaInfo: 0x14,
    ContentType: 0x18,
    FreshnessPeriod: 0x19,
    FinalBlock: 0x1A,
    Content: 0x15,
    DSigInfo: 0x16,
    DSigValue: 0x17,
    SigType: 0x1B,
    KeyLocator: 0x1C,
    KeyDigest: 0x1D,
    SigNonce: 0x26,
    SigTime: 0x28,
    SigSeqNum: 0x2A,
    ValidityPeriod: 0xFD,
    NotBefore: 0xFE,
    NotAfter: 0xFF,
    Nack: 0x0320,
    NackReason: 0x0321
};
const $dca48e99102f4a59$export$717e3e1d62a80637 = {
    Sha256: 0x00,
    Sha256WithRsa: 0x01,
    Sha256WithEcdsa: 0x03,
    HmacWithSha256: 0x04,
    Ed25519: 0x05,
    Null: 0xC8
};
const $dca48e99102f4a59$export$e20760d063e21623 = {
    Congestion: 50,
    Duplicate: 100,
    NoRoute: 150
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};


function $5035fd21bc2dae0c$var$asArrayBufferView(T, a) {
    if (a instanceof T) return a;
    if ("buffer" in a) return new T(a.buffer, a.byteOffset, a.byteLength);
    return new T(a);
}
function $5035fd21bc2dae0c$export$db814d038928c649(a) {
    return $5035fd21bc2dae0c$var$asArrayBufferView(Uint8Array, a);
}
function $5035fd21bc2dae0c$export$e5b360987746a572(a) {
    return $5035fd21bc2dae0c$var$asArrayBufferView(DataView, a);
}

const $253fa8a956219ce2$var$INT2HEX = {};
for(let b = 0; b <= 0xFF; ++b)$253fa8a956219ce2$var$INT2HEX[b] = b.toString(16).padStart(2, "0").toUpperCase();
const $253fa8a956219ce2$var$HEX2INT = {};
for(let b = 0; b <= 0xF; ++b){
    const ch = b.toString(16);
    $253fa8a956219ce2$var$HEX2INT[ch.toLowerCase()] = b;
    $253fa8a956219ce2$var$HEX2INT[ch.toUpperCase()] = b;
}
function $253fa8a956219ce2$export$7ea66e3774a60b67(buf) {
    let s = "";
    for (const b of buf)s += $253fa8a956219ce2$var$INT2HEX[b];
    return s;
}
(function(toHex) {
    /** Conversion table from byte (0x00~0xFF) to upper-case hexadecimal. */ toHex.TABLE = $253fa8a956219ce2$var$INT2HEX;
})($253fa8a956219ce2$export$7ea66e3774a60b67 || ($253fa8a956219ce2$export$7ea66e3774a60b67 = {}));
function $253fa8a956219ce2$export$1a8ceedbd5845648(s) {
    const b = new Uint8Array(s.length / 2);
    for(let i = 0; i < b.length; ++i)b[i] = $253fa8a956219ce2$var$HEX2INT[s[i * 2]] << 4 | $253fa8a956219ce2$var$HEX2INT[s[i * 2 + 1]];
    return b;
}
(function(fromHex) {
    /** Conversion table from hexadecimal digit (case insensitive) to nibble. */ fromHex.TABLE = $253fa8a956219ce2$var$HEX2INT;
})($253fa8a956219ce2$export$1a8ceedbd5845648 || ($253fa8a956219ce2$export$1a8ceedbd5845648 = {}));
const $253fa8a956219ce2$var$textEncoder = new TextEncoder();
const $253fa8a956219ce2$var$textDecoder = new TextDecoder();
function $253fa8a956219ce2$export$b4b216764bb846eb(s) {
    return $253fa8a956219ce2$var$textEncoder.encode(s);
}
function $253fa8a956219ce2$export$c7c5cef950a4d2fc(buf) {
    return $253fa8a956219ce2$var$textDecoder.decode(buf);
}



class $cbe5f05228192684$var$Nni1 {
    n;
    constructor(n){
        this.n = n;
    }
    encodeTo(encoder) {
        encoder.prependRoom(1)[0] = this.n;
    }
}
class $cbe5f05228192684$var$Nni2 {
    n;
    constructor(n){
        this.n = n;
    }
    encodeTo(encoder) {
        (0, $5035fd21bc2dae0c$export$e5b360987746a572)(encoder.prependRoom(2)).setUint16(0, this.n);
    }
}
class $cbe5f05228192684$var$Nni4 {
    n;
    constructor(n){
        this.n = n;
    }
    encodeTo(encoder) {
        (0, $5035fd21bc2dae0c$export$e5b360987746a572)(encoder.prependRoom(4)).setUint32(0, this.n);
    }
}
class $cbe5f05228192684$var$Nni8Number {
    n;
    constructor(n){
        this.n = n;
    }
    encodeTo(encoder) {
        const dv = (0, $5035fd21bc2dae0c$export$e5b360987746a572)(encoder.prependRoom(8));
        dv.setUint32(0, this.n / 0x100000000);
        dv.setUint32(4, this.n);
    }
}
class $cbe5f05228192684$var$Nni8Big {
    n;
    constructor(n){
        this.n = n;
    }
    encodeTo(encoder) {
        (0, $5035fd21bc2dae0c$export$e5b360987746a572)(encoder.prependRoom(8)).setBigUint64(0, this.n);
    }
}
function $cbe5f05228192684$var$decode32(dv) {
    switch(dv.byteLength){
        case 1:
            return dv.getUint8(0);
        case 2:
            return dv.getUint16(0);
        case 4:
            return dv.getUint32(0);
    }
    throw new Error("incorrect TLV-LENGTH of NNI");
}
const $cbe5f05228192684$var$EncodeNniClass = {
    1: $cbe5f05228192684$var$Nni1,
    2: $cbe5f05228192684$var$Nni2,
    4: $cbe5f05228192684$var$Nni4,
    8: $cbe5f05228192684$var$Nni8Number
};
function $cbe5f05228192684$export$3984f7cff3211fbd(n, { len: len, unsafe: unsafe = false } = {}) {
    if (len) {
        if (len === 8 && typeof n === "bigint") return new $cbe5f05228192684$var$Nni8Big(n);
        return new $cbe5f05228192684$var$EncodeNniClass[len](Number(n));
    }
    if (typeof n === "bigint") switch(true){
        case n < 0x100000000n:
            n = Number(n);
            break;
        case n <= 0xffffffffffffffffn:
            return new $cbe5f05228192684$var$Nni8Big(n);
        default:
            throw new RangeError("NNI is too large");
    }
    switch(true){
        case n < 0:
            throw new RangeError("NNI cannot be negative");
        case n < 0x100:
            return new $cbe5f05228192684$var$Nni1(n);
        case n < 0x10000:
            return new $cbe5f05228192684$var$Nni2(n);
        case n < 0x100000000:
            return new $cbe5f05228192684$var$Nni4(n);
        case n <= (unsafe ? 0xFFFFFFFFFFFFFFFF : Number.MAX_SAFE_INTEGER):
            return new $cbe5f05228192684$var$Nni8Number(n);
        default:
            throw new RangeError("NNI is too large");
    }
}
(function(NNI) {
    /** Determine if len is a valid length of encoded NNI. */ function isValidLength(len) {
        return !!$cbe5f05228192684$var$EncodeNniClass[len];
    }
    NNI.isValidLength = isValidLength;
    function decode(value, { len: len, big: big = false, unsafe: unsafe = false } = {}) {
        if (len && value.byteLength !== len) throw new Error(`incorrect TLV-LENGTH of NNI${len}`);
        const dv = (0, $5035fd21bc2dae0c$export$e5b360987746a572)(value);
        if (big) return dv.byteLength === 8 ? dv.getBigUint64(0) : BigInt($cbe5f05228192684$var$decode32(dv));
        if (dv.byteLength === 8) {
            const n = dv.getUint32(0) * 0x100000000 + dv.getUint32(4);
            if (!unsafe && !Number.isSafeInteger(n)) throw new RangeError(`NNI is too large ${(0, $253fa8a956219ce2$export$7ea66e3774a60b67)(value)}`);
            return n;
        }
        return $cbe5f05228192684$var$decode32(dv);
    }
    NNI.decode = decode;
})($cbe5f05228192684$export$3984f7cff3211fbd || ($cbe5f05228192684$export$3984f7cff3211fbd = {}));


class $62b60d7067469a95$var$DecodedTlv {
    type;
    buf;
    offsetT;
    offsetV;
    offsetE;
    get length() {
        return this.offsetE - this.offsetV;
    }
    get value() {
        return this.buf.subarray(this.offsetV, this.offsetE);
    }
    get tlv() {
        return this.buf.subarray(this.offsetT, this.offsetE);
    }
    get size() {
        return this.offsetE - this.offsetT;
    }
    get decoder() {
        return new $62b60d7067469a95$export$f9de6ca0bc043724(this.tlv);
    }
    get vd() {
        return new $62b60d7067469a95$export$f9de6ca0bc043724(this.value);
    }
    get nni() {
        return (0, $cbe5f05228192684$export$3984f7cff3211fbd).decode(this.value);
    }
    get nniBig() {
        return (0, $cbe5f05228192684$export$3984f7cff3211fbd).decode(this.value, {
            big: true
        });
    }
    get text() {
        return (0, $253fa8a956219ce2$export$c7c5cef950a4d2fc)(this.value);
    }
    get before() {
        return this.buf.subarray(0, this.offsetT);
    }
    get after() {
        return this.buf.subarray(this.offsetE);
    }
    constructor(type, buf, offsetT, offsetV, offsetE){
        this.type = type;
        this.buf = buf;
        this.offsetT = offsetT;
        this.offsetV = offsetV;
        this.offsetE = offsetE;
    }
}
class $62b60d7067469a95$export$f9de6ca0bc043724 {
    input;
    constructor(input){
        this.input = input;
        this.dv = (0, $5035fd21bc2dae0c$export$e5b360987746a572)(input);
    }
    dv;
    offset = 0;
    /** Determine whether end of input has been reached. */ get eof() {
        return this.offset >= this.input.length;
    }
    /**
     * Ensure EOF has been reached.
     *
     * @throws Error
     * Thrown if EOF has not been reached.
     */ throwUnlessEof() {
        if (!this.eof) throw new Error("junk after end of TLV");
    }
    /**
     * Read the next TLV structure from input.
     * @returns TLV structure.
     *
     * @throws Error
     * Thrown if there isn't a complete TLV structure in the input.
     */ read() {
        const offsetT = this.offset;
        const type = this.readVarNum();
        const length = this.readVarNum();
        const offsetV = this.offset;
        if (length === undefined || (this.offset += length) > this.input.length) throw new Error(`TLV at offset ${offsetT} is incomplete`);
        // length!==undefined implies type!==undefined
        return new $62b60d7067469a95$var$DecodedTlv(type, this.input, offsetT, offsetV, this.offset);
    }
    /** Read a Decodable object. */ decode(d) {
        return d.decodeFrom(this);
    }
    /**
     * Read a variable-size number.
     * @returns The number up to uint32 or `undefined` if there isn't a complete number.
     */ readVarNum() {
        if (this.eof) return undefined;
        switch(this.input[this.offset]){
            case 0xFD:
                this.offset += 3;
                if (this.offset > this.input.length) return undefined;
                return this.dv.getUint16(this.offset - 2);
            case 0xFE:
                this.offset += 5;
                if (this.offset > this.input.length) return undefined;
                return this.dv.getUint32(this.offset - 4);
            case 0xFF:
                // JavaScript cannot reliably represent 64-bit integers
                return undefined;
            default:
                this.offset += 1;
                return this.input[this.offset - 1];
        }
    }
}
(function(Decoder) {
    /**
     * Decode a single object from Uint8Array.
     * @param input - Input buffer, which should contain the encoded object and nothing else.
     * @param d - Decodable object type.
     * @returns Decoded object.
     *
     * @throws Error
     * Thrown if the input cannot be decoded as the specified object type, or there's junk leftover.
     */ function decode(input, d) {
        const decoder = new Decoder(input);
        const res = d.decodeFrom(decoder);
        decoder.throwUnlessEof();
        return res;
    }
    Decoder.decode = decode;
})($62b60d7067469a95$export$f9de6ca0bc043724 || ($62b60d7067469a95$export$f9de6ca0bc043724 = {}));

var $7a3ddb66cda07bbd$var$isProduction = false;
var $7a3ddb66cda07bbd$var$prefix = 'Invariant failed';
function $7a3ddb66cda07bbd$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($7a3ddb66cda07bbd$var$isProduction) throw new Error($7a3ddb66cda07bbd$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($7a3ddb66cda07bbd$var$prefix, ": ").concat(provided) : $7a3ddb66cda07bbd$var$prefix;
    throw new Error(value);
}


function $afff391ff1bb9a74$var$sizeofVarNum(n) {
    if (n < 0xFD) return 1;
    if (n <= 0xFFFF) return 3;
    if (n <= 0xFFFFFFFF) return 5;
    // 64-bit integers may lose precision in Number type, and it's rarely useful
    throw new Error("VAR-NUMBER is too large");
}
function $afff391ff1bb9a74$var$writeVarNum(room, dv, off, n) {
    if (n < 0xFD) room[off++] = n;
    else if (n <= 0xFFFF) {
        room[off++] = 0xFD;
        dv.setUint16(off, n);
    } else {
        room[off++] = 0xFE;
        dv.setUint32(off, n);
    }
}
class $afff391ff1bb9a74$export$a50aceb0e02a00aa {
    constructor(initSize = 2048){
        this.buf = new ArrayBuffer(initSize);
        this.off = initSize;
    }
    buf;
    off;
    /** Return encoding output size. */ get size() {
        return this.buf.byteLength - this.off;
    }
    /** Obtain encoding output. */ get output() {
        return new Uint8Array(this.buf, this.off);
    }
    /**
     * Make room to prepend an object.
     * @param sizeofObject - Object size.
     * @returns Room to write object.
     */ prependRoom(sizeofObject) {
        if (this.off < sizeofObject) this.grow(sizeofObject);
        this.off -= sizeofObject;
        return new Uint8Array(this.buf, this.off, sizeofObject);
    }
    /** Prepend TLV-TYPE and TLV-LENGTH. */ prependTypeLength(tlvType, tlvLength) {
        const sizeofT = $afff391ff1bb9a74$var$sizeofVarNum(tlvType);
        const sizeofL = $afff391ff1bb9a74$var$sizeofVarNum(tlvLength);
        const room = this.prependRoom(sizeofT + sizeofL);
        const dv = (0, $5035fd21bc2dae0c$export$e5b360987746a572)(room);
        $afff391ff1bb9a74$var$writeVarNum(room, dv, 0, tlvType);
        $afff391ff1bb9a74$var$writeVarNum(room, dv, sizeofT, tlvLength);
    }
    /**
     * Prepend TLV-VALUE.
     *
     * @remarks
     * Elements are prepended in the reverse order, so that they would appear in the output
     * in the same order as the parameter order.
     */ prependValue(...tlvValue) {
        for(let i = tlvValue.length - 1; i >= 0; --i)this.encode(tlvValue[i]);
    }
    prependTlv(tlvType, arg2, ...tlvValue) {
        const hasOmitEmpty = arg2 === $afff391ff1bb9a74$export$a50aceb0e02a00aa.OmitEmpty;
        if (!hasOmitEmpty) tlvValue.unshift(arg2);
        const sizeBefore = this.size;
        this.prependValue(...tlvValue);
        const tlvLength = this.size - sizeBefore;
        if (tlvLength > 0 || !hasOmitEmpty) this.prependTypeLength(tlvType, tlvLength);
    }
    /** Prepend `Encodable`. */ encode(obj) {
        if (obj instanceof Uint8Array) this.prependRoom(obj.length).set(obj);
        else if (typeof obj?.encodeTo === "function") obj.encodeTo(this);
        else if (Array.isArray(obj)) {
            if (typeof obj[0] === "number") this.prependTlv(...obj);
            else this.prependValue(...obj);
        } else (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(obj === undefined || obj === false, "obj is not Encodable");
    }
    grow(sizeofRoom) {
        const sizeofGrowth = 2048 + sizeofRoom;
        const buf = new ArrayBuffer(sizeofGrowth + this.size);
        new Uint8Array(buf, sizeofGrowth).set(this.output);
        this.buf = buf;
        this.off = sizeofGrowth;
    }
}
(function(Encoder) {
    /**
     * Indicate that TLV should be skipped if TLV-VALUE is empty.
     * @see {@link EncodableTlv}
     */ Encoder.OmitEmpty = Symbol("@ndn/tlv#OmitEmpty");
    /** Encode a single object into Uint8Array. */ function encode(obj, initBufSize) {
        const encoder = new Encoder(initBufSize);
        encoder.encode(obj);
        return encoder.output;
    }
    Encoder.encode = encode;
    /**
     * Extract the encoding output of an element while writing to a parent encoder.
     * @param obj - Encodable element.
     * @param cb - Function to receive the encoding output of `obj`.
     * @returns Wrapped Encodable object.
     */ function extract(obj, cb) {
        return {
            encodeTo (encoder) {
                const sizeBefore = encoder.size;
                encoder.encode(obj);
                cb(encoder.output.subarray(0, encoder.size - sizeBefore));
            }
        };
    }
    Encoder.extract = extract;
})($afff391ff1bb9a74$export$a50aceb0e02a00aa || ($afff391ff1bb9a74$export$a50aceb0e02a00aa = {}));


function $028ff0e68fa07526$export$c4e2ecac49351ef2(n, typeName, arg3, arg4) {
    const [min = 0, max = Number.MAX_SAFE_INTEGER] = arg4 === undefined ? [
        0,
        arg3
    ] : [
        arg3,
        arg4
    ];
    if (!(Number.isInteger(n) && n >= min && n <= max)) throw new RangeError(`${n} is not an integer or out of ${typeName} valid range`);
    return n;
}


var $69c6492f44d10951$exports = {};
$69c6492f44d10951$exports = function(a, b) {
    if (typeof a.compare === 'function') return a.compare(b);
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    var i = 0;
    var len = Math.min(x, y);
    while(i < len){
        if (a[i] !== b[i]) break;
        ++i;
    }
    if (i !== len) {
        x = a[i];
        y = b[i];
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};



const $afbf8ffa5073dea4$var$bufferCompare = (0, $8e874a2fb001c377$export$da59b14a69baef04)((0, (/*@__PURE__*/$parcel$interopDefault($69c6492f44d10951$exports)))).default;
function $afbf8ffa5073dea4$var$assertType(t) {
    return (0, $028ff0e68fa07526$export$c4e2ecac49351ef2)(t, "Component TLV-TYPE", 0x01, 0xFFFF);
}
const $afbf8ffa5073dea4$var$CHAR_ENCODE = {};
for(let b = 0x00; b <= 0xFF; ++b){
    const s = String.fromCodePoint(b);
    $afbf8ffa5073dea4$var$CHAR_ENCODE[b] = /[\w.~-]/i.test(s) ? s : `%${(0, $253fa8a956219ce2$export$7ea66e3774a60b67).TABLE[b]}`;
}
const $afbf8ffa5073dea4$var$CODEPOINT_PERCENT = "%".codePointAt(0);
const $afbf8ffa5073dea4$var$CODEPOINT_PERIOD = ".".codePointAt(0);
const $afbf8ffa5073dea4$var$encoderHeadroom = 10;
class $afbf8ffa5073dea4$export$16fa2f45be04daa8 {
    static decodeFrom(decoder) {
        const { tlv: tlv } = decoder.read();
        return new $afbf8ffa5073dea4$export$16fa2f45be04daa8(tlv);
    }
    /** Parse from URI representation, or return existing Component. */ static from(input) {
        if (input instanceof $afbf8ffa5073dea4$export$16fa2f45be04daa8) return input;
        let type = (0, $dca48e99102f4a59$export$c506431d6b27243b).GenericNameComponent;
        let posValue = 0;
        const posEqual = input.indexOf("=");
        if (posEqual >= 1) try {
            type = $afbf8ffa5073dea4$var$assertType(Number.parseInt(input, 10));
            posValue = posEqual + 1;
        } catch  {}
        const maxLength = input.length - posValue;
        const encoder = new (0, $afff391ff1bb9a74$export$a50aceb0e02a00aa)($afbf8ffa5073dea4$var$encoderHeadroom + maxLength);
        const value = encoder.prependRoom(maxLength);
        let length = 0;
        let hasNonPeriods = false;
        for(let i = posValue; i < input.length;){
            let b = input.codePointAt(i);
            hasNonPeriods ||= b !== $afbf8ffa5073dea4$var$CODEPOINT_PERIOD;
            if (b === $afbf8ffa5073dea4$var$CODEPOINT_PERCENT) {
                b = (0, $253fa8a956219ce2$export$1a8ceedbd5845648).TABLE[input[i + 1]] << 4 | (0, $253fa8a956219ce2$export$1a8ceedbd5845648).TABLE[input[i + 2]];
                i += 3;
            } else ++i;
            value[length++] = b;
        }
        if (!hasNonPeriods && length >= 3) length -= 3;
        return new $afbf8ffa5073dea4$export$16fa2f45be04daa8(type, encoder, length);
    }
    constructor(arg1 = (0, $dca48e99102f4a59$export$c506431d6b27243b).GenericNameComponent, arg2, length){
        if (arg1 instanceof Uint8Array) {
            this.tlv = arg1;
            const decoder = new (0, $62b60d7067469a95$export$f9de6ca0bc043724)(arg1);
            ({ type: this.type, value: this.value } = decoder.read());
            decoder.throwUnlessEof();
        } else {
            this.type = arg1;
            let encoder;
            let tailroom = 0;
            if (arg2 instanceof (0, $afff391ff1bb9a74$export$a50aceb0e02a00aa)) {
                encoder = arg2;
                tailroom = encoder.size - length;
            } else {
                const value = typeof arg2 === "string" ? (0, $253fa8a956219ce2$export$b4b216764bb846eb)(arg2) : arg2;
                length = value?.length ?? 0;
                encoder = new (0, $afff391ff1bb9a74$export$a50aceb0e02a00aa)($afbf8ffa5073dea4$var$encoderHeadroom + length);
                encoder.encode(value);
            }
            encoder.prependTypeLength(this.type, length);
            this.tlv = encoder.output;
            if (tailroom !== 0) this.tlv = this.tlv.subarray(0, -tailroom);
            this.value = this.tlv.subarray(this.tlv.length - length);
        }
        $afbf8ffa5073dea4$var$assertType(this.type);
    }
    /** Whole TLV. */ tlv;
    /** TLV-TYPE. */ type;
    /** TLV-VALUE. */ value;
    /** TLV-LENGTH. */ get length() {
        return this.value.length;
    }
    /** TLV-VALUE interpreted as UTF-8 string. */ get text() {
        return (0, $253fa8a956219ce2$export$c7c5cef950a4d2fc)(this.value);
    }
    /** Get URI string. */ toString() {
        let s = `${this.type}=`;
        let hasNonPeriods = false;
        for (const b of this.value){
            hasNonPeriods ||= b !== $afbf8ffa5073dea4$var$CODEPOINT_PERIOD;
            s += $afbf8ffa5073dea4$var$CHAR_ENCODE[b];
        }
        if (!hasNonPeriods) s += "...";
        return s;
    }
    encodeTo(encoder) {
        encoder.encode(this.tlv);
    }
    /** Determine if component follows a naming convention. */ is(convention) {
        return convention.match(this);
    }
    /** Convert with naming convention. */ as(convention) {
        (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(convention.match(this), "component does not follow convention");
        return convention.parse(this);
    }
    /** Compare this component with other. */ compare(other) {
        return $afbf8ffa5073dea4$export$16fa2f45be04daa8.compare(this, $afbf8ffa5073dea4$export$16fa2f45be04daa8.from(other));
    }
    /** Determine if this component equals other. */ equals(other) {
        return this.compare(other) === $afbf8ffa5073dea4$export$16fa2f45be04daa8.CompareResult.EQUAL;
    }
}
(function(Component) {
    /** Component compare result. */ let CompareResult;
    (function(CompareResult) {
        /** lhs is less than rhs */ CompareResult[CompareResult["LT"] = -2] = "LT";
        /** lhs and rhs are equal */ CompareResult[CompareResult["EQUAL"] = 0] = "EQUAL";
        /** lhs is greater than rhs */ CompareResult[CompareResult["GT"] = 2] = "GT";
    })(CompareResult = Component.CompareResult || (Component.CompareResult = {}));
    /** Compare two components. */ function compare(lhs, rhs) {
        return 2 * Math.sign(lhs.type - rhs.type || lhs.length - rhs.length || $afbf8ffa5073dea4$var$bufferCompare(lhs.value, rhs.value));
    }
    Component.compare = compare;
})($afbf8ffa5073dea4$export$16fa2f45be04daa8 || ($afbf8ffa5073dea4$export$16fa2f45be04daa8 = {}));





const $1ea7d5babaea91fd$var$DIGEST_LENGTH = 32;
class $1ea7d5babaea91fd$var$DigestComp {
    tt;
    altUriPrefix;
    altUriRegex;
    constructor(tt, altUriPrefix){
        this.tt = tt;
        this.altUriPrefix = altUriPrefix;
        this.altUriRegex = new RegExp(`^${altUriPrefix}=([0-9a-fA-F]{${2 * $1ea7d5babaea91fd$var$DIGEST_LENGTH}})$`);
    }
    match(comp) {
        return comp.type === this.tt && comp.length === $1ea7d5babaea91fd$var$DIGEST_LENGTH;
    }
    create(v) {
        if (v.length !== $1ea7d5babaea91fd$var$DIGEST_LENGTH) throw new Error(`digest length must be ${$1ea7d5babaea91fd$var$DIGEST_LENGTH}`);
        return new (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8)(this.tt, v);
    }
    parse(comp) {
        return comp.value;
    }
    toAltUri(comp) {
        return `${this.altUriPrefix}=${(0, $253fa8a956219ce2$export$7ea66e3774a60b67)(comp.value).toLowerCase()}`;
    }
    fromAltUri(input) {
        const m = this.altUriRegex.exec(input);
        if (!m) return undefined;
        return new (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8)(this.tt, (0, $253fa8a956219ce2$export$1a8ceedbd5845648)(m[1]));
    }
}
class $1ea7d5babaea91fd$var$ImplicitDigestComp extends $1ea7d5babaea91fd$var$DigestComp {
    /** Remove ImplicitDigest if present at last component. */ strip(name) {
        if (name.get(-1)?.is(this)) return name.getPrefix(-1);
        return name;
    }
}
const $1ea7d5babaea91fd$export$312d47269475b73e = new $1ea7d5babaea91fd$var$ImplicitDigestComp((0, $dca48e99102f4a59$export$c506431d6b27243b).ImplicitSha256DigestComponent, "sha256digest");
class $1ea7d5babaea91fd$var$ParamsDigestPlaceHolder extends (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8) {
}
class $1ea7d5babaea91fd$var$ParamsDigestComp extends $1ea7d5babaea91fd$var$DigestComp {
    /** ParamsDigest placeholder during Interest encoding. */ PLACEHOLDER = new $1ea7d5babaea91fd$var$ParamsDigestPlaceHolder(this.tt, "placeholder");
    /** Determine if comp is a ParamsDigest placeholder. */ isPlaceholder(comp) {
        return comp instanceof $1ea7d5babaea91fd$var$ParamsDigestPlaceHolder;
    }
    /** Find ParamsDigest or placeholder in name. */ findIn(name, matchPlaceholder = true) {
        return name.comps.findIndex((comp)=>this.match(comp) || matchPlaceholder && this.isPlaceholder(comp));
    }
}
const $1ea7d5babaea91fd$export$d1ea42819d5de7fa = new $1ea7d5babaea91fd$var$ParamsDigestComp((0, $dca48e99102f4a59$export$c506431d6b27243b).ParametersSha256DigestComponent, "params-sha256");






class $7b68f219f2171656$export$c7bd411105e2dec3 {
    static decodeFrom(decoder) {
        const { value: value } = decoder.read();
        return new $7b68f219f2171656$export$c7bd411105e2dec3(value);
    }
    /**
     * Create Name from Name or Name URI.
     *
     * @remarks
     * This is more efficient than `new Name(input)` if input is already a Name.
     */ static from(input) {
        return input instanceof $7b68f219f2171656$export$c7bd411105e2dec3 ? input : new $7b68f219f2171656$export$c7bd411105e2dec3(input);
    }
    constructor(arg1, parseComponent = (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).from){
        if (arg1 === undefined) this.valueEncoderBufSize = 0;
        else if (arg1 instanceof $7b68f219f2171656$export$c7bd411105e2dec3) {
            this.comps = arg1.comps;
            this.value_ = arg1.value_;
            this.uri_ = arg1.uri_;
            this.hex_ = arg1.hex_;
        } else if (typeof arg1 === "string") {
            for (const comp of arg1.replace(/^(?:ndn:)?\/*/, "").split("/"))if (comp !== "") this.comps.push(parseComponent(comp));
            this.valueEncoderBufSize = arg1.length + 4 * this.comps.length;
        } else if (Array.isArray(arg1)) this.comps = Array.from(arg1, (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).from);
        else if (arg1 instanceof Uint8Array) {
            this.value_ = arg1;
            const decoder = new (0, $62b60d7067469a95$export$f9de6ca0bc043724)(this.value_);
            while(!decoder.eof)this.comps.push(decoder.decode((0, $afbf8ffa5073dea4$export$16fa2f45be04daa8)));
        }
    }
    /** List of name components. */ comps = [];
    valueEncoderBufSize;
    value_;
    uri_;
    hex_;
    /** Number of name components. */ get length() {
        return this.comps.length;
    }
    /** Name TLV-VALUE. */ get value() {
        this.value_ ??= (0, $afff391ff1bb9a74$export$a50aceb0e02a00aa).encode(this.comps, this.valueEncoderBufSize ?? 256);
        return this.value_;
    }
    /** Name TLV-VALUE hexadecimal representation, good for map keys. */ get valueHex() {
        this.hex_ ??= (0, $253fa8a956219ce2$export$7ea66e3774a60b67)(this.value);
        return this.hex_;
    }
    /**
     * Retrieve i-th component.
     * @param i - Component index. Negative number counts from the end.
     * @returns i-th component, or `undefined` if it does not exist.
     */ get(i) {
        return this.comps.at(i);
    }
    /**
     * Retrieve i-th component.
     * @param i - Component index. Negative number counts from the end.
     * @returns i-th component.
     *
     * @throws RangeError
     * Thrown if i-th component does not exist.
     */ at(i) {
        const comp = this.get(i);
        if (!comp) throw new RangeError(`component ${i} out of range`);
        return comp;
    }
    /** Get URI string. */ toString() {
        this.uri_ ??= `/${this.comps.map((comp)=>comp.toString()).join("/")}`;
        return this.uri_;
    }
    /** Get sub name `[begin,end)`. */ slice(begin, end) {
        return new $7b68f219f2171656$export$c7bd411105e2dec3(this.comps.slice(begin, end));
    }
    /** Get prefix of `n` components. */ getPrefix(n) {
        return this.slice(0, n);
    }
    append(...args) {
        let suffix;
        if (args.length === 2 && typeof args[0].create === "function") suffix = [
            args[0].create(args[1])
        ];
        else suffix = args;
        return new $7b68f219f2171656$export$c7bd411105e2dec3([
            ...this.comps,
            ...suffix
        ]);
    }
    /** Return a copy of Name with i-th component replaced with `comp`. */ replaceAt(i, comp) {
        return new $7b68f219f2171656$export$c7bd411105e2dec3(this.comps.toSpliced(i, 1, comp));
    }
    /** Compare with other name. */ compare(other) {
        return $7b68f219f2171656$export$c7bd411105e2dec3.compare(this, $7b68f219f2171656$export$c7bd411105e2dec3.from(other));
    }
    /** Determine if this name equals other. */ equals(other) {
        other = $7b68f219f2171656$export$c7bd411105e2dec3.from(other);
        if (this.hex_ !== undefined && other.hex_ !== undefined) return this.hex_ === other.hex_;
        return this.length === other.length && $7b68f219f2171656$var$comparePrefix(this, other, this.length) === $7b68f219f2171656$export$c7bd411105e2dec3.CompareResult.EQUAL;
    }
    /** Determine if this name is a prefix of other. */ isPrefixOf(other) {
        other = $7b68f219f2171656$export$c7bd411105e2dec3.from(other);
        if (this.hex_ !== undefined && other.hex_ !== undefined) return other.hex_.startsWith(this.hex_);
        return this.length <= other.length && $7b68f219f2171656$var$comparePrefix(this, other, this.length) === $7b68f219f2171656$export$c7bd411105e2dec3.CompareResult.EQUAL;
    }
    encodeTo(encoder) {
        if (this.value_) encoder.prependTlv((0, $dca48e99102f4a59$export$c506431d6b27243b).Name, this.value_);
        else encoder.prependTlv((0, $dca48e99102f4a59$export$c506431d6b27243b).Name, ...this.comps);
    }
}
(function(Name) {
    /** Determine if obj is Name or Name URI. */ function isNameLike(obj) {
        return obj instanceof Name || typeof obj === "string";
    }
    Name.isNameLike = isNameLike;
    /** Name compare result. */ let CompareResult;
    (function(CompareResult) {
        /** lhs is less than, but not a prefix of rhs */ CompareResult[CompareResult["LT"] = -2] = "LT";
        /** lhs is a prefix of rhs */ CompareResult[CompareResult["LPREFIX"] = -1] = "LPREFIX";
        /** lhs and rhs are equal */ CompareResult[CompareResult["EQUAL"] = 0] = "EQUAL";
        /** rhs is a prefix of lhs */ CompareResult[CompareResult["RPREFIX"] = 1] = "RPREFIX";
        /** rhs is less than, but not a prefix of lhs */ CompareResult[CompareResult["GT"] = 2] = "GT";
    })(CompareResult = Name.CompareResult || (Name.CompareResult = {}));
    /** Compare two names. */ function compare(lhs, rhs) {
        const commonSize = Math.min(lhs.length, rhs.length);
        const cmp = $7b68f219f2171656$var$comparePrefix(lhs, rhs, commonSize);
        if (cmp !== CompareResult.EQUAL) return cmp;
        if (lhs.length > commonSize) return CompareResult.RPREFIX;
        if (rhs.length > commonSize) return CompareResult.LPREFIX;
        return CompareResult.EQUAL;
    }
    Name.compare = compare;
})($7b68f219f2171656$export$c7bd411105e2dec3 || ($7b68f219f2171656$export$c7bd411105e2dec3 = {}));
/** Compare first n components between two names. */ function $7b68f219f2171656$var$comparePrefix(lhs, rhs, n) {
    for(let i = 0; i < n; ++i){
        const cmp = lhs.comps[i].compare(rhs.comps[i]);
        if (cmp !== (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).CompareResult.EQUAL) return cmp;
    }
    return $7b68f219f2171656$export$c7bd411105e2dec3.CompareResult.EQUAL;
}


class $ec071845fb084a75$export$ba5acd398f166b94 {
    conventions;
    constructor(conventions){
        this.conventions = conventions;
    }
    /** Print component in alternate URI syntax */ ofComponent = (comp)=>{
        for (const conv of this.conventions){
            if (conv.match(comp)) return conv.toAltUri(comp);
        }
        return comp.toString();
    };
    /** Print name in alternate URI syntax. */ ofName = (name)=>`/${name.comps.map((comp)=>this.ofComponent(comp)).join("/")}`;
    /** Parse component from alternate URI syntax */ parseComponent = (input)=>{
        for (const conv of this.conventions){
            const comp = conv.fromAltUri(input);
            if (comp) return comp;
        }
        return (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).from(input);
    };
    /** Parse name from alternate URI syntax. */ parseName = (input)=>new (0, $7b68f219f2171656$export$c7bd411105e2dec3)(input, this.parseComponent);
}
class $ec071845fb084a75$var$Generic {
    match({ type: type }) {
        return type === (0, $dca48e99102f4a59$export$c506431d6b27243b).GenericNameComponent;
    }
    create() {
        throw new TypeError("not supported");
    }
    parse() {
        throw new TypeError("not supported");
    }
    toAltUri(comp) {
        return comp.toString().slice(2);
    }
    fromAltUri() {
        return undefined;
    }
}
const $ec071845fb084a75$export$235fc6c736994a90 = new $ec071845fb084a75$export$ba5acd398f166b94([
    new $ec071845fb084a75$var$Generic(),
    (0, $1ea7d5babaea91fd$export$312d47269475b73e),
    (0, $1ea7d5babaea91fd$export$d1ea42819d5de7fa)
]);





class $59e1d30d8902c01d$var$Typed {
    tt;
    constructor(tt){
        this.tt = tt;
    }
    get type() {
        return this.tt;
    }
    match(comp) {
        return comp.type === this.tt;
    }
}
class $59e1d30d8902c01d$var$TypedString extends $59e1d30d8902c01d$var$Typed {
    create(v) {
        return new (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8)(this.tt, v);
    }
    parse(comp) {
        return comp.text;
    }
}
class $59e1d30d8902c01d$var$TypedNumberBase extends $59e1d30d8902c01d$var$Typed {
    altUriPrefix;
    altUriRegex;
    constructor(tt, altUriPrefix){
        super(tt);
        this.altUriPrefix = altUriPrefix;
        this.altUriRegex = new RegExp(`^${altUriPrefix}(\\d+)$`);
    }
    create(v) {
        return new (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8)((0, $afff391ff1bb9a74$export$a50aceb0e02a00aa).encode([
            this.tt,
            (0, $cbe5f05228192684$export$3984f7cff3211fbd)(v)
        ], 12));
    }
    match(comp) {
        return super.match(comp) && (0, $cbe5f05228192684$export$3984f7cff3211fbd).isValidLength(comp.length);
    }
    toAltUri(comp) {
        return this.altUriPrefix + (0, $cbe5f05228192684$export$3984f7cff3211fbd).decode(comp.value, {
            big: true
        });
    }
    fromAltUri(input) {
        const m = this.altUriRegex.exec(input);
        if (!m) return undefined;
        return this.create(BigInt(m[1]));
    }
}
class $59e1d30d8902c01d$var$TypedNumber extends $59e1d30d8902c01d$var$TypedNumberBase {
    parse(comp) {
        return (0, $cbe5f05228192684$export$3984f7cff3211fbd).decode(comp.value);
    }
}
class $59e1d30d8902c01d$var$TypedBig extends $59e1d30d8902c01d$var$TypedNumberBase {
    parse(comp) {
        return (0, $cbe5f05228192684$export$3984f7cff3211fbd).decode(comp.value, {
            big: true
        });
    }
}
class $59e1d30d8902c01d$var$TypedNumberBig extends $59e1d30d8902c01d$var$TypedNumber {
    constructor(...args){
        super(...args);
        this.big = new $59e1d30d8902c01d$var$TypedBig(...args);
    }
    big;
}
class $59e1d30d8902c01d$var$TypedTimestamp extends $59e1d30d8902c01d$var$TypedNumber {
    unit;
    max;
    constructor(tt, unit, max){
        super(tt, "t=");
        this.unit = unit;
        this.max = max;
    }
    create(v) {
        if (v instanceof Date) v = v.getTime() * 1000;
        else v = Number(v) * this.unit;
        this.checkMax(v);
        return super.create(v);
    }
    parse(comp) {
        const v = super.parse(comp);
        this.checkMax(v);
        return v / this.unit;
    }
    checkMax(v) {
        (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(v <= this.max, "timestamp number too large");
    }
}
function $59e1d30d8902c01d$var$makeTimestampConvention(tt) {
    const ms = new $59e1d30d8902c01d$var$TypedTimestamp(tt, 1000, 8787511468039992);
    const us = new $59e1d30d8902c01d$var$TypedTimestamp(tt, 1, Number.MAX_SAFE_INTEGER);
    return Object.assign(ms, {
        ms: ms,
        us: us
    });
}
const $59e1d30d8902c01d$export$4e1c72b50fbc6f4f = new $59e1d30d8902c01d$var$TypedNumberBig((0, $dca48e99102f4a59$export$c506431d6b27243b).GenericNameComponent, "");
const $59e1d30d8902c01d$export$d1c5cf242bfe5091 = new $59e1d30d8902c01d$var$TypedString(0x20);
const $59e1d30d8902c01d$export$d202430443160157 = new $59e1d30d8902c01d$var$TypedNumberBig(0x21, "seg=");
const $59e1d30d8902c01d$export$524e8f6a40f3194a = new $59e1d30d8902c01d$var$TypedNumberBig(0x32, "seg=");
const $59e1d30d8902c01d$export$d53aa5c5ab432700 = $59e1d30d8902c01d$export$524e8f6a40f3194a;
const $59e1d30d8902c01d$export$b3d44e0904c2cf6 = new $59e1d30d8902c01d$var$TypedNumberBig(0x22, "off=");
const $59e1d30d8902c01d$export$2b106014e446e51f = new $59e1d30d8902c01d$var$TypedNumberBig(0x34, "off=");
const $59e1d30d8902c01d$export$35bdb41b9199e46f = $59e1d30d8902c01d$export$2b106014e446e51f;
const $59e1d30d8902c01d$export$41fd023379c9cf94 = new $59e1d30d8902c01d$var$TypedNumberBig(0x23, "v=");
const $59e1d30d8902c01d$export$25672b98380db6b8 = new $59e1d30d8902c01d$var$TypedNumberBig(0x36, "v=");
const $59e1d30d8902c01d$export$682c179f50ab847d = $59e1d30d8902c01d$export$25672b98380db6b8;
const $59e1d30d8902c01d$export$39995c8e38723242 = $59e1d30d8902c01d$var$makeTimestampConvention(0x24);
const $59e1d30d8902c01d$export$e9f94ce133216af6 = $59e1d30d8902c01d$var$makeTimestampConvention(0x38);
const $59e1d30d8902c01d$export$d9bcbd5e1ff81430 = $59e1d30d8902c01d$export$e9f94ce133216af6;
const $59e1d30d8902c01d$export$9e0ce2badcab06e3 = new $59e1d30d8902c01d$var$TypedNumberBig(0x25, "seq=");
const $59e1d30d8902c01d$export$1ac9becf312d3e06 = new $59e1d30d8902c01d$var$TypedNumberBig(0x3A, "seq=");
const $59e1d30d8902c01d$export$3f4faefbec4933dd = $59e1d30d8902c01d$export$1ac9becf312d3e06;


const $71d1e6bb840df0e0$export$de482c96112551d3 = new (0, $ec071845fb084a75$export$ba5acd398f166b94)([
    (0, $59e1d30d8902c01d$export$d202430443160157),
    (0, $59e1d30d8902c01d$export$b3d44e0904c2cf6),
    (0, $59e1d30d8902c01d$export$41fd023379c9cf94),
    (0, $59e1d30d8902c01d$export$39995c8e38723242).us,
    (0, $59e1d30d8902c01d$export$9e0ce2badcab06e3),
    ...(0, $ec071845fb084a75$export$235fc6c736994a90).conventions
]);
const $71d1e6bb840df0e0$export$a762e0169bb683e = new (0, $ec071845fb084a75$export$ba5acd398f166b94)([
    (0, $59e1d30d8902c01d$export$524e8f6a40f3194a),
    (0, $59e1d30d8902c01d$export$2b106014e446e51f),
    (0, $59e1d30d8902c01d$export$25672b98380db6b8),
    (0, $59e1d30d8902c01d$export$e9f94ce133216af6).us,
    (0, $59e1d30d8902c01d$export$1ac9becf312d3e06),
    ...(0, $ec071845fb084a75$export$235fc6c736994a90).conventions
]);
const $71d1e6bb840df0e0$export$235fc6c736994a90 = $71d1e6bb840df0e0$export$a762e0169bb683e;








class $912a61c4fdd23832$export$43a0c30a7aa6b893 extends (0, $9d72a09537a5cbc3$export$16fa2f45be04daa8) {
    render() {
        const { route: route, showFlags: showFlags = true, children: children } = this.props;
        return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, children, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, route.origin), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, route.cost), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
            show: showFlags
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
            show: route.childInherit
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("i", {
            title: "child-inherit",
            class: "flag",
            style: "background:#39cccc;"
        }, "I")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
            show: route.capture
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("i", {
            title: "capture",
            class: "flag",
            style: "background:#f012be;"
        }, "C")))));
    }
}


const $03873d71726c3f02$var$counterColumns = {
    rxInterest: "RX Interest",
    rxData: "RX Data",
    rxNack: "RX Nack",
    txInterest: "TX Interest",
    txData: "TX Data",
    txNack: "TX Nack"
};
function $03873d71726c3f02$export$ac83c019838597bb({ face: face }) {
    const status = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e));
    const routes = status.getFaceRoutes(face.id);
    const traffic = status.diffFaceCounters(face, (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$748e303ef81f8503)));
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $9d72a09537a5cbc3$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("h2", null, "Face ", face.id), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("table", {
        class: "pure-table pure-table-bordered"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, "local"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
        colSpan: 2
    }, face.local)), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, "remote"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
        colSpan: 2
    }, face.remote)), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, "MTU"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
        colSpan: 2
    }, face.mtu)), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, "flags"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
        colSpan: 2
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)($03873d71726c3f02$var$FaceFlags, {
        flags: face.flags
    }))), Object.entries($03873d71726c3f02$var$counterColumns).map(([key, title])=>/*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", {
            key: key
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, title), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, face.cnt[key]), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, traffic[key].toFixed(2), " /s")))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
        show: routes.length > 0
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("h3", null, "Routes"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)($03873d71726c3f02$var$FaceRoutes, {
        routes: routes
    })));
}
const $03873d71726c3f02$var$flagDisplay = {
    local: [
        "L",
        "ff851b"
    ],
    "on-demand": [
        "OD",
        "7fdbff"
    ],
    permanent: [
        "P",
        "01ff70"
    ],
    "multi-access": [
        "M",
        "f012be"
    ],
    "congestion-marking": [
        "CM",
        "b10dc9"
    ]
};
function $03873d71726c3f02$var$FaceFlags({ flags: flags }) {
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $9d72a09537a5cbc3$export$ffb0004e005737fa), null, flags.map((flag)=>{
        const [label, color] = $03873d71726c3f02$var$flagDisplay[flag];
        return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("i", {
            key: flag,
            title: flag,
            class: "flag",
            style: `background:#${color};`
        }, label);
    }));
}
function $03873d71726c3f02$var$FaceRoutes({ routes: routes }) {
    const nav = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$54335253c59b49ae));
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("table", {
        class: "pure-table pure-table-bordered",
        style: "table-layout:fixed; word-break:break-all;"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("colgroup", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("col", {
        style: "width:60%;"
    }), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("col", {
        style: "width:20%;"
    }), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("col", {
        style: "width:20%;"
    })), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("thead", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "name"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "origin"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "cost"))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tbody", null, routes.map((route)=>/*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $912a61c4fdd23832$export$43a0c30a7aa6b893), {
            key: `${route.prefix.valueHex} ${route.origin}`,
            route: route,
            showFlags: false
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
            onClick: ()=>nav.rib(route.prefix)
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
            href: "javascript:;"
        }, (0, $71d1e6bb840df0e0$export$235fc6c736994a90).ofName(route.prefix)))))));
}









function $fe7cfa56bdc74dc0$export$aa04a3ece9e844fc({ face: face, highlight: highlight, onClick: onClick }) {
    const status = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e));
    const routes = status.getFaceRoutes(face.id);
    const traffic = status.diffFaceCounters(face, (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$748e303ef81f8503)));
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    const trafficSum = Object.values(traffic).reduce((sum, v)=>sum + v, 0);
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", {
        class: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))({
            "pure-table-odd": highlight
        })
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
        onClick: onClick
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
        href: "javascript:;"
    }, face.id)), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, face.title), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, routes.length), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, Math.ceil(trafficSum)));
}


function $9a6549c8d7f84b2e$export$cffd21afb035ce9c({ selected: selected }) {
    const { faces: faces } = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e));
    const nav = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$54335253c59b49ae));
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("table", {
        class: "pure-table pure-table-bordered"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("thead", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "id"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "title"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "routes"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "traffic"))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tbody", null, faces.map((face)=>/*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $fe7cfa56bdc74dc0$export$aa04a3ece9e844fc), {
            key: face.id,
            face: face,
            highlight: face.id === selected,
            onClick: ()=>nav.face(face.id)
        }))));
}


function $677fbadc348f4a56$export$fd4b6d5db54c4eb2({ selected: selected }) {
    const status = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e));
    const face = selected ? status.getFace(selected) : undefined;
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-g"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-u-1 pure-u-lg-11-24"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("h1", null, status.faces.length, " faces"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $9a6549c8d7f84b2e$export$cffd21afb035ce9c), {
        selected: selected
    })), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-u-1 pure-u-lg-1-24"
    }), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-u-1 pure-u-lg-12-24"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
        show: !!face
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $03873d71726c3f02$export$ac83c019838597bb), {
        face: face
    }))));
}






function $d6aee708ec0d1c58$export$d7a9e6ef755e50e3() {
    const status = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e));
    const { host: host, faces: faces, rib: rib, routes: routes, defaultStrategy: defaultStrategy } = status;
    const { cnt: cnt } = host;
    const nav = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$54335253c59b49ae));
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $9d72a09537a5cbc3$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("h1", null, "NFD ", host.version), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("table", {
        class: "pure-table pure-table-bordered"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, "uptime"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, (0, $32fa34047bfe5216$export$2e2bcd8739ae039)(status.timestamp - host.startTime))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
        onClick: ()=>nav.face()
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
        href: "javascript:;"
    }, "faces")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, faces.length)), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, "name tree"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, cnt.nameTreeEntry, " entries")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, "FIB"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, cnt.fibEntry, " entries")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, "PIT"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, cnt.pitEntry, " entries, ", cnt.pitSatisfy, " satisfied, ", cnt.pitUnsatisfy, " unsatisfied")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, "CS"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, cnt.csEntry, " entries, ", cnt.csHit, " hits, ", cnt.csMiss, " misses")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
        onClick: ()=>nav.rib()
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
        href: "javascript:;"
    }, "RIB")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, rib.length, " entries, ", routes.length, " routes")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
        onClick: ()=>nav.strategies()
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
        href: "javascript:;"
    }, "strategy")), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, defaultStrategy))));
}







var $cf8271e76b04f9e6$exports = {};
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    $cf8271e76b04f9e6$exports = factory();
})($cf8271e76b04f9e6$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});



function $03dce7b716d75d66$export$1afea80721ed829b(name, needle) {
    return name.comps.some((comp)=>comp.equals(needle));
}


const $dbb47365724638a7$var$NLSR_ROUTER_COMP = (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).from("%C1.Router");
const $dbb47365724638a7$var$NLSR_OPERATOR_COMP = (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).from("%C1.Operator");
const $dbb47365724638a7$var$KEY_COMP = (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).from("KEY");
class $dbb47365724638a7$export$5acd95b63c8b07b3 extends (0, $9d72a09537a5cbc3$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        let toggles;
        try {
            const { hideNlsr: hideNlsr, hideKey: hideKey } = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($cf8271e76b04f9e6$exports))).get("NameFiltered"));
            toggles = {
                hideNlsr: !!hideNlsr,
                hideKey: !!hideKey
            };
        } catch  {
            toggles = {
                hideNlsr: false,
                hideKey: false
            };
        }
        this.state = {
            ...toggles,
            filter: this.makeFilter(toggles)
        };
    }
    makeFilter({ hideNlsr: hideNlsr, hideKey: hideKey }) {
        (0, (/*@__PURE__*/$parcel$interopDefault($cf8271e76b04f9e6$exports))).set("NameFiltered", JSON.stringify({
            hideNlsr: hideNlsr,
            hideKey: hideKey
        }), {
            path: "",
            sameSite: "Strict"
        });
        return (name)=>{
            switch(true){
                case hideNlsr && ((0, $03dce7b716d75d66$export$1afea80721ed829b)(name, $dbb47365724638a7$var$NLSR_ROUTER_COMP) || (0, $03dce7b716d75d66$export$1afea80721ed829b)(name, $dbb47365724638a7$var$NLSR_OPERATOR_COMP)):
                case hideKey && (0, $03dce7b716d75d66$export$1afea80721ed829b)(name, $dbb47365724638a7$var$KEY_COMP):
                    return false;
            }
            return true;
        };
    }
    handleChange = (toggle)=>()=>{
            this.setState((prev)=>{
                const toggles = {
                    ...prev,
                    [toggle]: !prev[toggle]
                };
                return {
                    [toggle]: !prev[toggle],
                    filter: this.makeFilter(toggles)
                };
            });
        };
    render() {
        if (!this.state.filter) return undefined;
        return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $9d72a09537a5cbc3$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("form", {
            class: "pure-form"
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("fieldset", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("label", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("input", {
            type: "checkbox",
            checked: this.state.hideNlsr,
            onChange: this.handleChange("hideNlsr")
        }), " ", "hide NLSR names"), " ", /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("label", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("input", {
            type: "checkbox",
            checked: this.state.hideKey,
            onChange: this.handleChange("hideKey")
        }), " ", "hide KEY names"))), this.props.children(this.state.filter));
    }
}







function $ac76649ccd899f34$export$126292a5635e9e4b({ entry: entry }) {
    const status = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e));
    const nav = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$54335253c59b49ae));
    const { prefix: prefix, routes: routes } = entry;
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $9d72a09537a5cbc3$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("h2", null, "RIB entry ", (0, $71d1e6bb840df0e0$export$235fc6c736994a90).ofName(prefix)), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("table", {
        class: "pure-table pure-table-bordered"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("thead", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", {
        colSpan: 2
    }, "face"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "origin"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "cost"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "flags"))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tbody", null, routes.map((route)=>/*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $912a61c4fdd23832$export$43a0c30a7aa6b893), {
            key: `${route.nexthop} ${route.origin}`,
            route: route
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
            onClick: ()=>nav.face(route.nexthop)
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
            href: "javascript:;"
        }, route.nexthop)), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, status.getFace(route.nexthop)?.title))))));
}








function $e142ffa4da513d5f$export$fe5aa6f0f2f7c079({ entry: entry, highlight: highlight, onClick: onClick }) {
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", {
        class: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))({
            "pure-table-odd": highlight
        })
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", {
        onClick: onClick
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("a", {
        href: "javascript:;"
    }, (0, $71d1e6bb840df0e0$export$235fc6c736994a90).ofName(entry.prefix))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, entry.routes.length));
}


function $5116f5457eabcd88$export$2ff53c604724212a({ selected: selected, filter: filter }) {
    const { rib: rib } = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e));
    const nav = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$54335253c59b49ae));
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("table", {
        class: "pure-table pure-table-bordered",
        style: "table-layout:fixed; word-break:break-all;"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("colgroup", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("col", {
        style: "width:80%;"
    }), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("col", {
        style: "width:20%;"
    })), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("thead", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "prefix"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "routes"))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tbody", null, rib.filter(({ prefix: prefix })=>filter(prefix)).map((entry)=>/*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $e142ffa4da513d5f$export$fe5aa6f0f2f7c079), {
            key: entry.prefix.valueHex,
            entry: entry,
            highlight: selected?.equals(entry.prefix),
            onClick: ()=>nav.rib(entry.prefix)
        }))));
}


function $6aac5cd092770164$export$2bcfe1535c64dcf6({ selected: selected }) {
    const status = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e));
    const entry = selected ? status.getRibEntry(selected) : undefined;
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-g"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-u-1 pure-u-lg-9-24"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("h1", null, status.routes.length, " routes in ", status.rib.length, " RIB entries"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $dbb47365724638a7$export$5acd95b63c8b07b3), null, (filter)=>/*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $5116f5457eabcd88$export$2ff53c604724212a), {
            selected: selected,
            filter: filter
        }))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-u-1 pure-u-lg-1-24"
    }), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
        class: "pure-u-1 pure-u-lg-14-24"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
        show: !!entry
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $ac76649ccd899f34$export$126292a5635e9e4b), {
        entry: entry
    }))));
}










function $343330e1b8a468c6$export$90f8755c1ab4f046({ filter: filter }) {
    const { strategies: strategies } = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e));
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("table", {
        class: "pure-table pure-table-bordered"
    }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("thead", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "name"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("th", null, "strategy"))), strategies.filter(({ prefix: prefix })=>filter(prefix)).map((sc)=>/*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("tr", {
            key: sc.prefix.valueHex
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, (0, $71d1e6bb840df0e0$export$235fc6c736994a90).ofName(sc.prefix)), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("td", null, sc.strategy))));
}


function $daff59998e945073$export$40b27805ac431149() {
    const { strategies: strategies } = (0, $1fdd316a03abfa38$export$fae74005e78b1a27)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e));
    return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $9d72a09537a5cbc3$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("h1", null, strategies.length, " strategy choices"), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $dbb47365724638a7$export$5acd95b63c8b07b3), null, (filter)=>/*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $343330e1b8a468c6$export$90f8755c1ab4f046), {
            filter: filter
        })));
}


class $f449f0b23fbc743a$export$86fbec116b87613f extends (0, $9d72a09537a5cbc3$export$16fa2f45be04daa8) {
    constructor(){
        super();
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        this.setState({
            currentTab: (0, $ac1dc4345d36ffa4$exports.get)("tab") || "Overview"
        });
    }
    componentDidMount() {
        this.props.requests.onFetched = (status)=>this.setState({
                status: status
            });
    }
    nav = {
        face: (id)=>{
            this.setState({
                currentTab: "Faces",
                currentFace: id
            });
        },
        rib: (name)=>{
            this.setState({
                currentTab: "Routes",
                currentRibEntry: name
            });
        },
        strategies: ()=>{
            this.setState({
                currentTab: "Strategies"
            });
        }
    };
    getSnapshotBeforeUpdate() {
        (0, $ac1dc4345d36ffa4$exports.set)("tab", this.state.currentTab);
    }
    render() {
        const { latest: latest, oldest: oldest } = this.props.requests;
        if (!latest || !oldest) return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $184d2ccc27df5fc4$export$669f6ea7d267feaf), {
            requests: this.props.requests
        });
        return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $4ddc8df16bccfebf$export$840ef5c626b2833e).Provider, {
            value: latest
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $4ddc8df16bccfebf$export$748e303ef81f8503).Provider, {
            value: oldest
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $4ddc8df16bccfebf$export$54335253c59b49ae).Provider, {
            value: this.nav
        }, this.renderView())));
    }
    renderView() {
        const { currentTab: tab } = this.state;
        const { version: version } = this.props.requests.latest.host;
        return /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $9d72a09537a5cbc3$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
            class: "pure-g"
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
            class: "pure-u-1"
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $21f3feca442f8f00$export$a6edb1992047cc25), {
            tabs: [
                "Overview",
                "Faces",
                "Routes",
                "Strategies",
                "About"
            ],
            selected: tab,
            onChange: (tab)=>this.setState({
                    currentTab: tab
                })
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("span", {
            class: "pure-menu-heading"
        }, "NFD ", version)))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("div", {
            class: "pure-g"
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)("section", {
            class: "pure-u-1"
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
            show: tab === "Overview"
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $d6aee708ec0d1c58$export$d7a9e6ef755e50e3), null)), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
            show: tab === "Faces"
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $677fbadc348f4a56$export$fd4b6d5db54c4eb2), {
            selected: this.state.currentFace
        })), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
            show: tab === "Routes"
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $6aac5cd092770164$export$2bcfe1535c64dcf6), {
            selected: this.state.currentRibEntry
        })), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
            show: tab === "Strategies"
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $daff59998e945073$export$40b27805ac431149), null)), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $80199810cc459725$export$1f9ff5f4a6c9361a), {
            show: tab === "About"
        }, /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $448fcf004b3856ad$export$c8424c4d8ba2150), null)))), /*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $70b7288ce14ac696$export$a06f1c675e846f6f), {
            requests: this.props.requests
        }));
    }
}


class $6062cb89e8539301$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(message);
        this.name = 'TimeoutError';
    }
}
class $6062cb89e8539301$export$18b052ffd8c84d7 extends Error {
    constructor(message){
        super();
        this.name = 'AbortError';
        this.message = message;
    }
}
/**
TODO: Remove AbortError and just throw DOMException when targeting Node 18.
*/ const $6062cb89e8539301$var$getDOMException = (errorMessage)=>globalThis.DOMException === undefined ? new $6062cb89e8539301$export$18b052ffd8c84d7(errorMessage) : new DOMException(errorMessage);
/**
TODO: Remove below function and just 'reject(signal.reason)' when targeting Node 18.
*/ const $6062cb89e8539301$var$getAbortedReason = (signal)=>{
    const reason = signal.reason === undefined ? $6062cb89e8539301$var$getDOMException('This operation was aborted.') : signal.reason;
    return reason instanceof Error ? reason : $6062cb89e8539301$var$getDOMException(reason);
};
function $6062cb89e8539301$export$2e2bcd8739ae039(promise, options) {
    const { milliseconds: milliseconds, fallback: fallback, message: message, customTimers: customTimers = {
        setTimeout: setTimeout,
        clearTimeout: clearTimeout
    } } = options;
    let timer;
    let abortHandler;
    const wrappedPromise = new Promise((resolve, reject)=>{
        if (typeof milliseconds !== 'number' || Math.sign(milliseconds) !== 1) throw new TypeError(`Expected \`milliseconds\` to be a positive number, got \`${milliseconds}\``);
        if (options.signal) {
            const { signal: signal } = options;
            if (signal.aborted) reject($6062cb89e8539301$var$getAbortedReason(signal));
            abortHandler = ()=>{
                reject($6062cb89e8539301$var$getAbortedReason(signal));
            };
            signal.addEventListener('abort', abortHandler, {
                once: true
            });
        }
        if (milliseconds === Number.POSITIVE_INFINITY) {
            promise.then(resolve, reject);
            return;
        }
        // We create the error outside of `setTimeout` to preserve the stack trace.
        const timeoutError = new $6062cb89e8539301$export$66d311bf29d5c89c();
        timer = customTimers.setTimeout.call(undefined, ()=>{
            if (fallback) {
                try {
                    resolve(fallback());
                } catch (error) {
                    reject(error);
                }
                return;
            }
            if (typeof promise.cancel === 'function') promise.cancel();
            if (message === false) resolve();
            else if (message instanceof Error) reject(message);
            else {
                timeoutError.message = message ?? `Promise timed out after ${milliseconds} milliseconds`;
                reject(timeoutError);
            }
        }, milliseconds);
        (async ()=>{
            try {
                resolve(await promise);
            } catch (error) {
                reject(error);
            }
        })();
    });
    const cancelablePromise = wrappedPromise.finally(()=>{
        cancelablePromise.clear();
        if (abortHandler && options.signal) options.signal.removeEventListener('abort', abortHandler);
    });
    cancelablePromise.clear = ()=>{
        customTimers.clearTimeout.call(undefined, timer);
        timer = undefined;
    };
    return cancelablePromise;
}


const $72858d2ce7cda3d1$var$normalizeEmitter = (emitter)=>{
    const addListener = emitter.addEventListener || emitter.on || emitter.addListener;
    const removeListener = emitter.removeEventListener || emitter.off || emitter.removeListener;
    if (!addListener || !removeListener) throw new TypeError('Emitter is not compatible');
    return {
        addListener: addListener.bind(emitter),
        removeListener: removeListener.bind(emitter)
    };
};
function $72858d2ce7cda3d1$export$2c4a4c4b47fca7e3(emitter, event, options) {
    let cancel;
    const returnValue = new Promise((resolve, reject)=>{
        options = {
            rejectionEvents: [
                'error'
            ],
            multiArgs: false,
            resolveImmediately: false,
            ...options
        };
        if (!(options.count >= 0 && (options.count === Number.POSITIVE_INFINITY || Number.isInteger(options.count)))) throw new TypeError('The `count` option should be at least 0 or more');
        options.signal?.throwIfAborted();
        // Allow multiple events
        const events = [
            event
        ].flat();
        const items = [];
        const { addListener: addListener, removeListener: removeListener } = $72858d2ce7cda3d1$var$normalizeEmitter(emitter);
        const onItem = (...arguments_)=>{
            const value = options.multiArgs ? arguments_ : arguments_[0];
            // eslint-disable-next-line unicorn/no-array-callback-reference
            if (options.filter && !options.filter(value)) return;
            items.push(value);
            if (options.count === items.length) {
                cancel();
                resolve(items);
            }
        };
        const rejectHandler = (error)=>{
            cancel();
            reject(error);
        };
        cancel = ()=>{
            for (const event of events)removeListener(event, onItem);
            for (const rejectionEvent of options.rejectionEvents)removeListener(rejectionEvent, rejectHandler);
        };
        for (const event of events)addListener(event, onItem);
        for (const rejectionEvent of options.rejectionEvents)addListener(rejectionEvent, rejectHandler);
        if (options.signal) options.signal.addEventListener('abort', ()=>{
            rejectHandler(options.signal.reason);
        }, {
            once: true
        });
        if (options.resolveImmediately) resolve(items);
    });
    returnValue.cancel = cancel;
    if (typeof options.timeout === 'number') {
        const timeout = (0, $6062cb89e8539301$export$2e2bcd8739ae039)(returnValue, {
            milliseconds: options.timeout
        });
        timeout.cancel = cancel;
        return timeout;
    }
    return returnValue;
}
function $72858d2ce7cda3d1$export$9f6cfc81102a9fd9(emitter, event, options) {
    if (typeof options === 'function') options = {
        filter: options
    };
    options = {
        ...options,
        count: 1,
        resolveImmediately: false
    };
    const arrayPromise = $72858d2ce7cda3d1$export$2c4a4c4b47fca7e3(emitter, event, options);
    const promise = arrayPromise.then((array)=>array[0]);
    promise.cancel = arrayPromise.cancel;
    return promise;
}
function $72858d2ce7cda3d1$export$b7721d92058efe1b(emitter, event, options) {
    if (typeof options === 'function') options = {
        filter: options
    };
    // Allow multiple events
    const events = [
        event
    ].flat();
    options = {
        rejectionEvents: [
            'error'
        ],
        resolutionEvents: [],
        limit: Number.POSITIVE_INFINITY,
        multiArgs: false,
        ...options
    };
    const { limit: limit } = options;
    const isValidLimit = limit >= 0 && (limit === Number.POSITIVE_INFINITY || Number.isInteger(limit));
    if (!isValidLimit) throw new TypeError('The `limit` option should be a non-negative integer or Infinity');
    options.signal?.throwIfAborted();
    if (limit === 0) // Return an empty async iterator to avoid any further cost
    return {
        [Symbol.asyncIterator] () {
            return this;
        },
        async next () {
            return {
                done: true,
                value: undefined
            };
        }
    };
    const { addListener: addListener, removeListener: removeListener } = $72858d2ce7cda3d1$var$normalizeEmitter(emitter);
    let isDone = false;
    let error;
    let hasPendingError = false;
    const nextQueue = [];
    const valueQueue = [];
    let eventCount = 0;
    let isLimitReached = false;
    const valueHandler = (...arguments_)=>{
        eventCount++;
        isLimitReached = eventCount === limit;
        const value = options.multiArgs ? arguments_ : arguments_[0];
        if (nextQueue.length > 0) {
            const { resolve: resolve } = nextQueue.shift();
            resolve({
                done: false,
                value: value
            });
            if (isLimitReached) cancel();
            return;
        }
        valueQueue.push(value);
        if (isLimitReached) cancel();
    };
    const cancel = ()=>{
        isDone = true;
        for (const event of events)removeListener(event, valueHandler);
        for (const rejectionEvent of options.rejectionEvents)removeListener(rejectionEvent, rejectHandler);
        for (const resolutionEvent of options.resolutionEvents)removeListener(resolutionEvent, resolveHandler);
        while(nextQueue.length > 0){
            const { resolve: resolve } = nextQueue.shift();
            resolve({
                done: true,
                value: undefined
            });
        }
    };
    const rejectHandler = (...arguments_)=>{
        error = options.multiArgs ? arguments_ : arguments_[0];
        if (nextQueue.length > 0) {
            const { reject: reject } = nextQueue.shift();
            reject(error);
        } else hasPendingError = true;
        cancel();
    };
    const resolveHandler = (...arguments_)=>{
        const value = options.multiArgs ? arguments_ : arguments_[0];
        // eslint-disable-next-line unicorn/no-array-callback-reference
        if (options.filter && !options.filter(value)) {
            cancel();
            return;
        }
        if (nextQueue.length > 0) {
            const { resolve: resolve } = nextQueue.shift();
            resolve({
                done: true,
                value: value
            });
        } else valueQueue.push(value);
        cancel();
    };
    for (const event of events)addListener(event, valueHandler);
    for (const rejectionEvent of options.rejectionEvents)addListener(rejectionEvent, rejectHandler);
    for (const resolutionEvent of options.resolutionEvents)addListener(resolutionEvent, resolveHandler);
    if (options.signal) options.signal.addEventListener('abort', ()=>{
        rejectHandler(options.signal.reason);
    }, {
        once: true
    });
    return {
        [Symbol.asyncIterator] () {
            return this;
        },
        async next () {
            if (valueQueue.length > 0) {
                const value = valueQueue.shift();
                return {
                    done: isDone && valueQueue.length === 0 && !isLimitReached,
                    value: value
                };
            }
            if (hasPendingError) {
                hasPendingError = false;
                throw error;
            }
            if (isDone) return {
                done: true,
                value: undefined
            };
            return new Promise((resolve, reject)=>{
                nextQueue.push({
                    resolve: resolve,
                    reject: reject
                });
            });
        },
        async return (value) {
            cancel();
            return {
                done: isDone,
                value: value
            };
        }
    };
}




const $67370eb8e1370a95$var$emptySet = new Set();
class $67370eb8e1370a95$export$8309310f4f3643db {
    keyOf;
    /**
     * Constructor.
     * @param keyOf - Function to transform input key to indexable key.
     */ constructor(keyOf){
        this.keyOf = keyOf;
    }
    m = new Map();
    get size() {
        return this.m.size;
    }
    has(key) {
        return this.m.has(this.keyOf(key));
    }
    get(key) {
        return this.m.get(this.keyOf(key))?.[1];
    }
    set(key, value) {
        this.m.set(this.keyOf(key), [
            key,
            value
        ]);
        return this;
    }
    delete(key) {
        return this.m.delete(this.keyOf(key));
    }
    [Symbol.iterator]() {
        return this.m.values();
    }
}
class $67370eb8e1370a95$export$fdc9020603d69f5a {
    /**
     * Constructor.
     * @param keyOf - Function to transform input key to indexable key.
     */ constructor(keyOf){
        this.m = new $67370eb8e1370a95$export$8309310f4f3643db(keyOf);
    }
    m;
    size_ = 0;
    /** Number of distinct keys. */ get dimension() {
        return this.m.size;
    }
    /** Number of values. */ get size() {
        return this.size_;
    }
    /** Count values associated with a key. */ count(key) {
        return this.m.get(key)?.size ?? 0;
    }
    /** List values associated with a key. */ list(key) {
        return this.m.get(key) ?? $67370eb8e1370a95$var$emptySet;
    }
    /**
     * Add a key-value pair.
     * Values are stored in a Set, so duplicates are skipped.
     * @returns count(key) after the operation.
     */ add(key, value) {
        let c = this.m.get(key);
        if (!c) {
            c = new Set();
            this.m.set(key, c);
        }
        const n = c.size;
        c.add(value);
        this.size_ += c.size - n;
        return c.size;
    }
    /**
     * Remove a key-value pair.
     * No-op if key-value does not exist.
     * @returns `count(key)` after the operation.
     */ remove(key, value) {
        const c = this.m.get(key);
        if (!c) return 0;
        const n = c.size;
        c.delete(value);
        this.size_ += c.size - n;
        if (c.size === 0) this.m.delete(key);
        return c.size;
    }
    /** Iterate over key and associated values. */ associations() {
        return this.m[Symbol.iterator]();
    }
    /** Iterate over key-value pairs. */ *[Symbol.iterator]() {
        for (const [key, values] of this.associations())for (const value of values)yield [
            key,
            value
        ];
    }
}
class $67370eb8e1370a95$export$c43b025112e292e2 extends $67370eb8e1370a95$export$fdc9020603d69f5a {
    constructor(){
        super((k)=>k);
    }
}
class $67370eb8e1370a95$export$fbd406807880576e {
    /**
     * Constructor.
     * @param keyOf - Function to transform input key to indexable key.
     */ constructor(keyOf){
        this.m = new $67370eb8e1370a95$export$8309310f4f3643db(keyOf);
    }
    m;
    size_ = 0;
    /** Number of distinct keys. */ get dimension() {
        return this.m.size;
    }
    /** Number of values. */ get size() {
        return this.size_;
    }
    /** Count occurrences of a key. */ count(key) {
        return this.m.get(key) ?? 0;
    }
    /**
     * Add a key.
     * @returns Number of occurrences after the operation.
     */ add(key) {
        const n = this.count(key) + 1;
        this.m.set(key, n);
        ++this.size_;
        return n;
    }
    /**
     * Remove a key.
     * No-op if key does not exist.
     * @returns Number of occurrences after the operation.
     */ remove(key) {
        let n = this.count(key);
        if (n === 0) return n;
        --this.size_;
        --n;
        if (n === 0) this.m.delete(key);
        else this.m.set(key, n);
        return n;
    }
    /** Iterate over key and number of occurrences. */ multiplicities() {
        return this.m[Symbol.iterator]();
    }
}


function $a9c3f3b834c4d83c$var$keyOf(nameOrHex) {
    return typeof nameOrHex === "string" ? nameOrHex : nameOrHex.valueHex;
}
class $a9c3f3b834c4d83c$export$ac6e1c51dc7b1284 extends (0, $67370eb8e1370a95$export$8309310f4f3643db) {
    constructor(){
        super($a9c3f3b834c4d83c$var$keyOf);
    }
}
class $a9c3f3b834c4d83c$export$37be79a638e0dccd extends (0, $67370eb8e1370a95$export$fdc9020603d69f5a) {
    constructor(){
        super($a9c3f3b834c4d83c$var$keyOf);
    }
}
class $a9c3f3b834c4d83c$export$a5030ff39b11e35e extends (0, $67370eb8e1370a95$export$fbd406807880576e) {
    constructor(){
        super($a9c3f3b834c4d83c$var$keyOf);
    }
}


var $62d6fec90a26ecd9$exports = {};
/**
 * Mnemonist MultiMap
 * ===================
 *
 * Implementation of a MultiMap with custom container.
 */ var $183149369fc563a7$exports = {};
/**
 * Obliterator Iterator Class
 * ===========================
 *
 * Simple class representing the library's iterators.
 */ /**
 * Iterator class.
 *
 * @constructor
 * @param {function} next - Next function.
 */ function $183149369fc563a7$var$Iterator(next) {
    if (typeof next !== 'function') throw new Error('obliterator/iterator: expecting a function!');
    this.next = next;
}
/**
 * If symbols are supported, we add `next` to `Symbol.iterator`.
 */ if (typeof Symbol !== 'undefined') $183149369fc563a7$var$Iterator.prototype[Symbol.iterator] = function() {
    return this;
};
/**
 * Returning an iterator of the given values.
 *
 * @param  {any...} values - Values.
 * @return {Iterator}
 */ $183149369fc563a7$var$Iterator.of = function() {
    var args = arguments, l = args.length, i = 0;
    return new $183149369fc563a7$var$Iterator(function() {
        if (i >= l) return {
            done: true
        };
        return {
            done: false,
            value: args[i++]
        };
    });
};
/**
 * Returning an empty iterator.
 *
 * @return {Iterator}
 */ $183149369fc563a7$var$Iterator.empty = function() {
    var iterator = new $183149369fc563a7$var$Iterator(function() {
        return {
            done: true
        };
    });
    return iterator;
};
/**
 * Returning an iterator over the given indexed sequence.
 *
 * @param  {string|Array} sequence - Target sequence.
 * @return {Iterator}
 */ $183149369fc563a7$var$Iterator.fromSequence = function(sequence) {
    var i = 0, l = sequence.length;
    return new $183149369fc563a7$var$Iterator(function() {
        if (i >= l) return {
            done: true
        };
        return {
            done: false,
            value: sequence[i++]
        };
    });
};
/**
 * Returning whether the given value is an iterator.
 *
 * @param  {any} value - Value.
 * @return {boolean}
 */ $183149369fc563a7$var$Iterator.is = function(value) {
    if (value instanceof $183149369fc563a7$var$Iterator) return true;
    return typeof value === 'object' && value !== null && typeof value.next === 'function';
};
/**
 * Exporting.
 */ $183149369fc563a7$exports = $183149369fc563a7$var$Iterator;


var $6e9134d47a83768a$exports = {};
/**
 * Obliterator ForEach Function
 * =============================
 *
 * Helper function used to easily iterate over mixed values.
 */ var $4f7a3e27c98ba070$export$194e7506be432e4c;
var $4f7a3e27c98ba070$export$26a0f98018bbcd89;
$4f7a3e27c98ba070$export$194e7506be432e4c = typeof ArrayBuffer !== 'undefined';
$4f7a3e27c98ba070$export$26a0f98018bbcd89 = typeof Symbol !== 'undefined';


var $6e9134d47a83768a$var$ARRAY_BUFFER_SUPPORT = $4f7a3e27c98ba070$export$194e7506be432e4c;
var $6e9134d47a83768a$var$SYMBOL_SUPPORT = $4f7a3e27c98ba070$export$26a0f98018bbcd89;
/**
 * Function able to iterate over almost any iterable JS value.
 *
 * @param  {any}      iterable - Iterable value.
 * @param  {function} callback - Callback function.
 */ $6e9134d47a83768a$exports = function forEach(iterable, callback) {
    var iterator, k, i, l, s;
    if (!iterable) throw new Error('obliterator/forEach: invalid iterable.');
    if (typeof callback !== 'function') throw new Error('obliterator/forEach: expecting a callback.');
    // The target is an array or a string or function arguments
    if (Array.isArray(iterable) || $6e9134d47a83768a$var$ARRAY_BUFFER_SUPPORT && ArrayBuffer.isView(iterable) || typeof iterable === 'string' || iterable.toString() === '[object Arguments]') {
        for(i = 0, l = iterable.length; i < l; i++)callback(iterable[i], i);
        return;
    }
    // The target has a #.forEach method
    if (typeof iterable.forEach === 'function') {
        iterable.forEach(callback);
        return;
    }
    // The target is iterable
    if ($6e9134d47a83768a$var$SYMBOL_SUPPORT && Symbol.iterator in iterable && typeof iterable.next !== 'function') iterable = iterable[Symbol.iterator]();
    // The target is an iterator
    if (typeof iterable.next === 'function') {
        iterator = iterable;
        i = 0;
        while(s = iterator.next(), s.done !== true){
            callback(s.value, i);
            i++;
        }
        return;
    }
    // The target is a plain object
    for(k in iterable)if (iterable.hasOwnProperty(k)) callback(iterable[k], k);
    return;
};


/**
 * MultiMap.
 *
 * @constructor
 */ function $62d6fec90a26ecd9$var$MultiMap(Container) {
    this.Container = Container || Array;
    this.items = new Map();
    this.clear();
    Object.defineProperty(this.items, 'constructor', {
        value: $62d6fec90a26ecd9$var$MultiMap,
        enumerable: false
    });
}
/**
 * Method used to clear the structure.
 *
 * @return {undefined}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.clear = function() {
    // Properties
    this.size = 0;
    this.dimension = 0;
    this.items.clear();
};
/**
 * Method used to set a value.
 *
 * @param  {any}      key   - Key.
 * @param  {any}      value - Value to add.
 * @return {MultiMap}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.set = function(key, value) {
    var container = this.items.get(key), sizeBefore;
    if (!container) {
        this.dimension++;
        container = new this.Container();
        this.items.set(key, container);
    }
    if (this.Container === Set) {
        sizeBefore = container.size;
        container.add(value);
        if (sizeBefore < container.size) this.size++;
    } else {
        container.push(value);
        this.size++;
    }
    return this;
};
/**
 * Method used to delete the given key.
 *
 * @param  {any}     key - Key to delete.
 * @return {boolean}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.delete = function(key) {
    var container = this.items.get(key);
    if (!container) return false;
    this.size -= this.Container === Set ? container.size : container.length;
    this.dimension--;
    this.items.delete(key);
    return true;
};
/**
 * Method used to delete the remove an item in the container stored at the
 * given key.
 *
 * @param  {any}     key - Key to delete.
 * @return {boolean}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.remove = function(key, value) {
    var container = this.items.get(key), wasDeleted, index;
    if (!container) return false;
    if (this.Container === Set) {
        wasDeleted = container.delete(value);
        if (wasDeleted) this.size--;
        if (container.size === 0) {
            this.items.delete(key);
            this.dimension--;
        }
        return wasDeleted;
    } else {
        index = container.indexOf(value);
        if (index === -1) return false;
        this.size--;
        if (container.length === 1) {
            this.items.delete(key);
            this.dimension--;
            return true;
        }
        container.splice(index, 1);
        return true;
    }
};
/**
 * Method used to return whether the given keys exists in the map.
 *
 * @param  {any}     key - Key to check.
 * @return {boolean}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.has = function(key) {
    return this.items.has(key);
};
/**
 * Method used to return the container stored at the given key or `undefined`.
 *
 * @param  {any}     key - Key to get.
 * @return {boolean}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.get = function(key) {
    return this.items.get(key);
};
/**
 * Method used to return the multiplicity of the given key, meaning the number
 * of times it is set, or, more trivially, the size of the attached container.
 *
 * @param  {any}     key - Key to check.
 * @return {number}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.multiplicity = function(key) {
    var container = this.items.get(key);
    if (typeof container === 'undefined') return 0;
    return this.Container === Set ? container.size : container.length;
};
$62d6fec90a26ecd9$var$MultiMap.prototype.count = $62d6fec90a26ecd9$var$MultiMap.prototype.multiplicity;
/**
 * Method used to iterate over each of the key/value pairs.
 *
 * @param  {function}  callback - Function to call for each item.
 * @param  {object}    scope    - Optional scope.
 * @return {undefined}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.forEach = function(callback, scope) {
    scope = arguments.length > 1 ? scope : this;
    // Inner iteration function is created here to avoid creating it in the loop
    var key;
    function inner(value) {
        callback.call(scope, value, key);
    }
    this.items.forEach(function(container, k) {
        key = k;
        container.forEach(inner);
    });
};
/**
 * Method used to iterate over each of the associations.
 *
 * @param  {function}  callback - Function to call for each item.
 * @param  {object}    scope    - Optional scope.
 * @return {undefined}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.forEachAssociation = function(callback, scope) {
    scope = arguments.length > 1 ? scope : this;
    this.items.forEach(callback, scope);
};
/**
 * Method returning an iterator over the map's keys.
 *
 * @return {Iterator}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.keys = function() {
    return this.items.keys();
};
/**
 * Method returning an iterator over the map's keys.
 *
 * @return {Iterator}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.values = function() {
    var iterator = this.items.values(), inContainer = false, countainer, step, i, l;
    if (this.Container === Set) return new $183149369fc563a7$exports(function next() {
        if (!inContainer) {
            step = iterator.next();
            if (step.done) return {
                done: true
            };
            inContainer = true;
            countainer = step.value.values();
        }
        step = countainer.next();
        if (step.done) {
            inContainer = false;
            return next();
        }
        return {
            done: false,
            value: step.value
        };
    });
    return new $183149369fc563a7$exports(function next() {
        if (!inContainer) {
            step = iterator.next();
            if (step.done) return {
                done: true
            };
            inContainer = true;
            countainer = step.value;
            i = 0;
            l = countainer.length;
        }
        if (i >= l) {
            inContainer = false;
            return next();
        }
        return {
            done: false,
            value: countainer[i++]
        };
    });
};
/**
 * Method returning an iterator over the map's entries.
 *
 * @return {Iterator}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.entries = function() {
    var iterator = this.items.entries(), inContainer = false, countainer, step, key, i, l;
    if (this.Container === Set) return new $183149369fc563a7$exports(function next() {
        if (!inContainer) {
            step = iterator.next();
            if (step.done) return {
                done: true
            };
            inContainer = true;
            key = step.value[0];
            countainer = step.value[1].values();
        }
        step = countainer.next();
        if (step.done) {
            inContainer = false;
            return next();
        }
        return {
            done: false,
            value: [
                key,
                step.value
            ]
        };
    });
    return new $183149369fc563a7$exports(function next() {
        if (!inContainer) {
            step = iterator.next();
            if (step.done) return {
                done: true
            };
            inContainer = true;
            key = step.value[0];
            countainer = step.value[1];
            i = 0;
            l = countainer.length;
        }
        if (i >= l) {
            inContainer = false;
            return next();
        }
        return {
            done: false,
            value: [
                key,
                countainer[i++]
            ]
        };
    });
};
/**
 * Method returning an iterator over the map's containers.
 *
 * @return {Iterator}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.containers = function() {
    return this.items.values();
};
/**
 * Method returning an iterator over the map's associations.
 *
 * @return {Iterator}
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.associations = function() {
    return this.items.entries();
};
/**
 * Attaching the #.entries method to Symbol.iterator if possible.
 */ if (typeof Symbol !== 'undefined') $62d6fec90a26ecd9$var$MultiMap.prototype[Symbol.iterator] = $62d6fec90a26ecd9$var$MultiMap.prototype.entries;
/**
 * Convenience known methods.
 */ $62d6fec90a26ecd9$var$MultiMap.prototype.inspect = function() {
    return this.items;
};
if (typeof Symbol !== 'undefined') $62d6fec90a26ecd9$var$MultiMap.prototype[Symbol.for('nodejs.util.inspect.custom')] = $62d6fec90a26ecd9$var$MultiMap.prototype.inspect;
$62d6fec90a26ecd9$var$MultiMap.prototype.toJSON = function() {
    return this.items;
};
/**
 * Static @.from function taking an arbitrary iterable & converting it into
 * a structure.
 *
 * @param  {Iterable} iterable  - Target iterable.
 * @param  {Class}    Container - Container.
 * @return {MultiMap}
 */ $62d6fec90a26ecd9$var$MultiMap.from = function(iterable, Container) {
    var map = new $62d6fec90a26ecd9$var$MultiMap(Container);
    $6e9134d47a83768a$exports(iterable, function(value, key) {
        map.set(key, value);
    });
    return map;
};
/**
 * Exporting.
 */ $62d6fec90a26ecd9$exports = $62d6fec90a26ecd9$var$MultiMap;


function $75de51155cf45ef0$export$9accc8beaa39b07a(ip) {
    return $75de51155cf45ef0$var$ipNames.get(ip) ?? ip;
}
const $75de51155cf45ef0$var$ipNames = new Map();
// eslint-disable-next-line unicorn/prefer-top-level-await
(async ()=>{
    try {
        const j = await (await fetch("https://testbed-status.named-data.net/testbed-nodes.json")).json();
        for (const [name, { ip_addresses: ip_addresses = [] }] of Object.entries(j))for (const ip of ip_addresses)$75de51155cf45ef0$var$ipNames.set(ip, `${ip} (${name})`);
    } catch (err) {
        console.warn(err);
    }
})();



class $4f1310986f1c1075$export$d517598d3abaff88 {
    timestamp = 0;
    host = {
        cnt: {}
    };
    faces = [];
    faceById = new Map();
    getFace(id) {
        return this.faceById.get(id);
    }
    diffFaceCounters(face, prev) {
        const duration = this.timestamp - (prev?.timestamp ?? 0);
        return $4f1310986f1c1075$var$diffPacketCounters(face.cnt, prev?.getFace(face.id)?.cnt, duration);
    }
    addFace(face) {
        $4f1310986f1c1075$var$describeFace(face);
        this.faces.push(face);
        this.faceById.set(face.id, face);
    }
    get rib() {
        return Array.from(this.ribEntryByName, ([, entry])=>entry);
    }
    routes = [];
    ribEntryByName = new (0, $a9c3f3b834c4d83c$export$ac6e1c51dc7b1284)();
    routesByFace = new (0, (/*@__PURE__*/$parcel$interopDefault($62d6fec90a26ecd9$exports)))();
    getRibEntry(name) {
        return this.ribEntryByName.get(name);
    }
    getFaceRoutes(id) {
        return this.routesByFace.get(id) ?? [];
    }
    addRoute(route) {
        let ribEntry = this.ribEntryByName.get(route.prefix);
        if (!ribEntry) {
            ribEntry = {
                prefix: route.prefix,
                capture: false,
                routes: []
            };
            this.ribEntryByName.set(route.prefix, ribEntry);
        }
        ribEntry.capture ||= route.capture;
        ribEntry.routes.push(route);
        this.routes.push(route);
        this.routesByFace.set(route.nexthop, route);
        const face = this.faceById.get(route.nexthop);
        if (face) $4f1310986f1c1075$var$describeFaceRoute(route, face);
    }
    strategies = [];
    defaultStrategy = "";
    addStrategy(sc) {
        $4f1310986f1c1075$var$describeStrategy(sc);
        this.strategies.push(sc);
        if (sc.prefix.length === 0) this.defaultStrategy = sc.strategy;
    }
}
function $4f1310986f1c1075$var$diffPacketCounters(current, prev, duration) {
    const result = {
        ...current
    };
    if (prev && duration > 0) for (const [key, value] of Object.entries(current))result[key] = (value - prev[key]) / duration * 1000;
    else for (const key of Object.keys(current))result[key] = 0;
    return result;
}
function $4f1310986f1c1075$var$prettyIp(s) {
    s = s.replace(/:6363$/, "");
    if (s.startsWith("[") && s.endsWith("]")) s = s.slice(1, -1);
    return (0, $75de51155cf45ef0$export$9accc8beaa39b07a)(s);
}
function $4f1310986f1c1075$var$describeFace(face) {
    const { local: local, remote: remote } = face;
    face.scheme = remote.replace(/:.*$/, "");
    face.title = face.remote;
    switch(face.scheme.replace(/\d$/, "")){
        case "tcp":
            face.title = `TCP ${$4f1310986f1c1075$var$prettyIp(remote.slice(7))}`;
            break;
        case "udp":
            if (remote.endsWith(":56363")) {
                let m = /^udp4:\/\/([^:]+):\d+$/.exec(local);
                if (m) {
                    face.title = `UDP IPv4 multicast on ${m[1]}`;
                    break;
                }
                m = /^udp6:\/\/[^%]+%([^\]%]+)]:56363$/.exec(remote);
                if (m) {
                    face.title = `UDP IPv6 multicast on ${m[1]}`;
                    break;
                }
            }
            face.title = `UDP ${$4f1310986f1c1075$var$prettyIp(remote.slice(7))}`;
            break;
        case "fd":
            face.scheme = "unix";
            face.title = `UNIX fd=${remote.slice(5)}`;
            break;
        case "ether":
            if (remote === "ether://[01:00:5e:00:17:aa]") face.title = `Ethernet multicast on ${local.slice(6)}`;
            break;
        case "internal":
            face.title = "NFD management";
            break;
        case "contentstore":
            face.scheme = "internal";
            face.title = "Content Store";
            break;
        case "null":
            face.scheme = "internal";
            face.title = "packet drop";
            break;
    }
}
const $4f1310986f1c1075$var$LOCALHOST_NFD = new (0, $7b68f219f2171656$export$c7bd411105e2dec3)("/localhost/nfd");
const $4f1310986f1c1075$var$PING_SUFFIX = (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).from("ping");
const $4f1310986f1c1075$var$NLSR_INFO_SUFFIX_1 = (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).from("INFO");
const $4f1310986f1c1075$var$NLSR_INFO_SUFFIX_2 = (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).from("nlsr");
const $4f1310986f1c1075$var$NLSR_ROUTER_COMP = (0, $afbf8ffa5073dea4$export$16fa2f45be04daa8).from("%C1.Router");
const $4f1310986f1c1075$var$LOCALHOP_AUTOCONF_HUB = new (0, $7b68f219f2171656$export$c7bd411105e2dec3)("/localhop/ndn-autoconf/hub");
function $4f1310986f1c1075$var$describeFaceRoute({ prefix: prefix }, face) {
    switch(true){
        case face.scheme === "unix" && $4f1310986f1c1075$var$LOCALHOST_NFD.equals(prefix):
            face.title = "NFD-RIB management";
            break;
        case face.scheme === "unix" && prefix.get(-1)?.equals($4f1310986f1c1075$var$PING_SUFFIX):
            face.title = `ping server ${(0, $71d1e6bb840df0e0$export$235fc6c736994a90).ofName(prefix.getPrefix(-1))}`;
            break;
        case face.scheme === "unix" && prefix.get(-1)?.equals($4f1310986f1c1075$var$NLSR_INFO_SUFFIX_1) && prefix.get(-2)?.equals($4f1310986f1c1075$var$NLSR_INFO_SUFFIX_2) && (0, $03dce7b716d75d66$export$1afea80721ed829b)(prefix, $4f1310986f1c1075$var$NLSR_ROUTER_COMP):
            face.title = `NLSR ${(0, $71d1e6bb840df0e0$export$235fc6c736994a90).ofName(prefix.getPrefix(-2))}`;
            break;
        case face.scheme === "unix" && $4f1310986f1c1075$var$LOCALHOP_AUTOCONF_HUB.equals(prefix):
            face.title = "autoconfig server";
            break;
    }
}
const $4f1310986f1c1075$var$LOCALHOST_NFD_STRATEGY = new (0, $7b68f219f2171656$export$c7bd411105e2dec3)("/localhost/nfd/strategy");
function $4f1310986f1c1075$var$describeStrategy(sc) {
    const name = (0, $71d1e6bb840df0e0$export$235fc6c736994a90).parseName(sc.strategy);
    if ($4f1310986f1c1075$var$LOCALHOST_NFD_STRATEGY.isPrefixOf(name) && name.length >= 5 && name.get(4).is((0, $59e1d30d8902c01d$export$682c179f50ab847d))) sc.strategy = `${(0, $71d1e6bb840df0e0$export$235fc6c736994a90).ofComponent(name.get(3))} v${name.get(4).as((0, $59e1d30d8902c01d$export$682c179f50ab847d))} ${(0, $71d1e6bb840df0e0$export$235fc6c736994a90).ofName(name.slice(5)).slice(1)}`;
}


const $51d06fc3bb44ed94$export$9792e829328f21df = {
    local: true,
    "on-demand": true,
    permanent: true,
    "multi-access": true,
    "congestion-marking": true
};


function $466215002481f015$export$2399001a612e3205(doc) {
    const result = new $466215002481f015$var$NfdStatusXml();
    result.parse(doc);
    return result;
}
class $466215002481f015$var$NfdStatusXml extends (0, $4f1310986f1c1075$export$d517598d3abaff88) {
    parse(doc) {
        if (doc.documentElement.namespaceURI !== "ndn:/localhost/nfd/status/1") throw new Error("invalid XML");
        for (const ele of $466215002481f015$var$iterElements(doc.documentElement))switch(ele.localName){
            case "generalStatus":
                this.parseGeneralStatus(ele);
                break;
            case "faces":
                this.parseFaces(ele);
                break;
            case "rib":
                this.parseRib(ele);
                break;
            case "cs":
                this.parseCs(ele);
                break;
            case "strategyChoices":
                this.parseStrategyChoices(ele);
                break;
        }
    }
    parseGeneralStatus(gsEle) {
        $466215002481f015$var$assignElements(this.host, gsEle, {
            version: [
                "version",
                "str"
            ],
            startTime: (text)=>this.host.startTime = Date.parse(`${text}Z`),
            currentTime: (text)=>this.timestamp = Date.parse(`${text}Z`)
        });
        $466215002481f015$var$assignElements(this.host.cnt, gsEle, {
            nNameTreeEntries: [
                "nameTreeEntry",
                "int"
            ],
            nFibEntries: [
                "fibEntry",
                "int"
            ],
            nPitEntries: [
                "pitEntry",
                "int"
            ],
            nMeasurementsEntries: [
                "mtEntry",
                "int"
            ],
            nCsEntries: [
                "csEntry",
                "int"
            ],
            nSatisfiedInterests: [
                "pitSatisfy",
                "int"
            ],
            nUnsatisfiedInterests: [
                "pitUnsatisfy",
                "int"
            ],
            packetCounters: $466215002481f015$var$parsePacketCounters(this.host.cnt)
        });
    }
    parseFaces(facesEle) {
        for (const faceEle of $466215002481f015$var$iterElements(facesEle)){
            const face = {
                flags: [],
                cnt: {}
            };
            $466215002481f015$var$assignElements(face, faceEle, {
                faceId: [
                    "id",
                    "int"
                ],
                localUri: [
                    "local",
                    "str"
                ],
                remoteUri: [
                    "remote",
                    "str"
                ],
                mtu: [
                    "mtu",
                    "int"
                ],
                faceScope: $466215002481f015$var$collectFlag(face.flags, (0, $51d06fc3bb44ed94$export$9792e829328f21df)),
                facePersistency: $466215002481f015$var$collectFlag(face.flags, (0, $51d06fc3bb44ed94$export$9792e829328f21df)),
                linkType: $466215002481f015$var$collectFlag(face.flags, (0, $51d06fc3bb44ed94$export$9792e829328f21df)),
                congestion: ()=>face.flags.push("congestion-marking"),
                packetCounters: $466215002481f015$var$parsePacketCounters(face.cnt)
            });
            this.addFace(face);
        }
    }
    parseRib(ribEle) {
        for (const ribEntryEle of $466215002481f015$var$iterElements(ribEle)){
            const prefix = {};
            $466215002481f015$var$assignElements(prefix, ribEntryEle, {
                prefix: [
                    "prefix",
                    "name"
                ],
                routes: (text, routesEle)=>{
                    for (const routeEle of $466215002481f015$var$iterElements(routesEle)){
                        const route = {
                            ...prefix,
                            childInherit: false,
                            capture: false
                        };
                        $466215002481f015$var$assignElements(route, routeEle, {
                            faceId: [
                                "nexthop",
                                "int"
                            ],
                            origin: [
                                "origin",
                                "str"
                            ],
                            cost: [
                                "cost",
                                "int"
                            ],
                            flags: (text, node)=>{
                                $466215002481f015$var$assignElements(route, node, {
                                    childInherit: [
                                        "childInherit",
                                        "true"
                                    ],
                                    ribCapture: [
                                        "capture",
                                        "true"
                                    ]
                                });
                            }
                        });
                        this.addRoute(route);
                    }
                }
            });
        }
    }
    parseCs(csEle) {
        $466215002481f015$var$assignElements(this.host.cnt, csEle, {
            nHits: [
                "csHit",
                "int"
            ],
            nMisses: [
                "csMiss",
                "int"
            ]
        });
    }
    parseStrategyChoices(scsEle) {
        for (const scEle of $466215002481f015$var$iterElements(scsEle)){
            const sc = {};
            $466215002481f015$var$assignElements(sc, scEle, {
                namespace: [
                    "prefix",
                    "name"
                ],
                strategy: (text, strategyEle)=>{
                    $466215002481f015$var$assignElements(sc, strategyEle, {
                        name: [
                            "strategy",
                            "str"
                        ]
                    });
                }
            });
            this.addStrategy(sc);
        }
    }
}
function* $466215002481f015$var$iterElements({ childNodes: childNodes }) {
    // eslint-disable-next-line unicorn/no-for-loop, @typescript-eslint/prefer-for-of
    for(let i = 0; i < childNodes.length; ++i){
        const child = childNodes[i];
        if (child.nodeType === child.ELEMENT_NODE) yield child;
    }
}
function $466215002481f015$var$assignElements(target, source, schema) {
    for (const ele of $466215002481f015$var$iterElements(source)){
        const instruction = schema[ele.localName];
        if (!instruction) continue;
        const text = ele.textContent ?? "";
        if (typeof instruction === "function") {
            instruction(text, ele);
            continue;
        } else {
            const [dst, type] = instruction;
            switch(type){
                case "int":
                    target[dst] = Number.parseInt(text, 10);
                    break;
                case "str":
                    target[dst] = text;
                    break;
                case "name":
                    target[dst] = (0, $71d1e6bb840df0e0$export$235fc6c736994a90).parseName(text);
                    break;
                case "true":
                    target[dst] = true;
                    break;
            }
        }
    }
    return target;
}
function $466215002481f015$var$collectFlag(target, accepts) {
    return (text)=>{
        if (accepts[text]) target.push(text);
    };
}
function $466215002481f015$var$parsePacketCounters(target) {
    return (text, packetCntEle)=>{
        for (const node of $466215002481f015$var$iterElements(packetCntEle))switch(node.localName){
            case "incomingPackets":
                $466215002481f015$var$assignElements(target, node, {
                    nInterests: [
                        "rxInterest",
                        "int"
                    ],
                    nData: [
                        "rxData",
                        "int"
                    ],
                    nNacks: [
                        "rxNack",
                        "int"
                    ]
                });
                break;
            case "outgoingPackets":
                $466215002481f015$var$assignElements(target, node, {
                    nInterests: [
                        "txInterest",
                        "int"
                    ],
                    nData: [
                        "txData",
                        "int"
                    ],
                    nNacks: [
                        "txNack",
                        "int"
                    ]
                });
                break;
        }
    };
}


class $07a8e56be448d8c3$export$f9643c966167957a {
    constructor(opts){
        Object.assign(this, opts);
    }
    onFetched;
    get host() {
        if (this.uri === "/") return location.hostname;
        return this.uri;
    }
    timer = 0;
    recents = [];
    get latest() {
        return this.recents[0];
    }
    get oldest() {
        return this.recents.at(-1);
    }
    start() {
        this.timer = setTimeout(this.update, 0);
    }
    stop() {
        clearTimeout(this.timer);
    }
    update = async ()=>{
        try {
            if (document.hidden) await (0, $72858d2ce7cda3d1$export$9f6cfc81102a9fd9)(document, "visibilitychange");
            const request = new Request(this.uri);
            request.headers.set("Accept", "application/xml; text/xml; */*");
            const response = await fetch(request);
            const doc = new DOMParser().parseFromString(await response.text(), "application/xml");
            const status = (0, $466215002481f015$export$2399001a612e3205)(doc);
            this.recents.unshift(status);
            this.recents.splice(this.history);
            this.onFetched?.(status);
        } catch (err) {
            console.warn(err);
        } finally{
            this.timer = setTimeout(this.update, this.interval + this.interval * 0.1 * Math.random());
        }
    };
}


window.addEventListener("load", ()=>{
    const { uri: uri = "/", interval: interval } = (0, (/*@__PURE__*/$parcel$interopDefault($358d0673515ab87d$exports))).parse(location.search, {
        depth: 1,
        ignoreQueryPrefix: true
    });
    let intervalMs = Number.parseInt(interval?.toString() ?? "", 10) * 1000;
    if (!intervalMs || intervalMs < 6000) intervalMs = 6000;
    const requests = new (0, $07a8e56be448d8c3$export$f9643c966167957a)({
        uri: uri.toString(),
        interval: intervalMs,
        history: Math.ceil(30000 / intervalMs)
    });
    document.title = `NFD Status: ${requests.host}`;
    requests.start();
    (0, $9d72a09537a5cbc3$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $9d72a09537a5cbc3$export$c8a8987d4410bf2d)((0, $f449f0b23fbc743a$export$86fbec116b87613f), {
        requests: requests
    }), document.body);
});


//# sourceMappingURL=NDNts-NFD-status-page.a1f68ffb.js.map
